// export const roles = {
//   ADMIN: "Admin",
//   BUYER: "Buyer",
//   SELLER: "Seller",
// };

const randomJoiningDate = () =>
  new Date(
    Date.now() - Math.floor(Math.random() * 365 * 24 * 60 * 60 * 1000),
  ).toISOString();

export const specializations = {
  buyer: [
    { value: "event planner", label: "Event Planner" },
    { value: "incentive house", label: "Incentive House" },
    { value: "travel house", label: "Travel House" },
    {
      value: "professional conference organizer",
      label: "Professional Conference Organizer",
    },
    { value: "exhibition organisers", label: "Exhibition Organisers" },
    {
      value: "wedding social/ event planner",
      label: "Wedding Planner/ Social Events Planner",
    },
    { value: "corporate", label: "Corporate" },
    { value: "association", label: "Association" },
  ],
  seller: [
    {
      value: "national tourism organization",
      label: "National Tourism Organization",
    },
    {
      value: "regional tourism organization",
      label: "Regional Tourism Organization",
    },
    {
      value: "hospitality group",
      label: "Hospitality Group",
    },
    {
      value: "hotel",
      label: "Hotel",
    },
    {
      value: "venue",
      label: "Venue",
    },
    {
      value: "national convention bureau",
      label: "National Convention Bureau",
    },
    {
      value: "regional convention bureau",
      label: "Regional Convention Bureau",
    },
    {
      value: "convention center",
      label: "Convention Center",
    },
    {
      value: "airline",
      label: "Airline",
    },
    {
      value: "representation company",
      label: "Representation Company",
    },
    {
      value: "attraction",
      label: "Attraction",
    },
    {
      value: "supplier",
      label: "Supplier",
    },
    {
      value: "other",
      label: "Other",
    },
  ],
  supplier: [
    {
      value: "air charter",
      label: "Air Charter",
    },
    {
      value: "audio video lighting",
      label: "Audio Video Lighting",
    },
    {
      value: "bar management",
      label: "Bar Management",
    },
    {
      value: "branding and fabrication",
      label: "Branding & Fabrication",
    },
    {
      value: "brands that cater",
      label: "Brands That Cater",
    },
    {
      value: "caterers",
      label: "Caterers",
    },
    {
      value: "confectionery",
      label: "Confectionery",
    },
    {
      value: "dance_choreography",
      label: "Dance Choreography",
    },
    {
      value: "Decor",
      label: "Decor",
    },
    {
      value: "Entertainment",
      label: "Entertainment(Artistis & Agencies)",
    },
    {
      value: "exhibition booth building",
      label: "Exhibition Booth Building",
    },
    {
      value: "film production",
      label: "Film Production",
    },
    {
      value: "floral decor",
      label: "Floral Decor",
    },
    {
      value: "furniture rental",
      label: "Furniture Rental",
    },
    {
      value: "gifting and merchandise",
      label: "Gifting & Merchandise",
    },
    {
      value: "hair and makeup",
      label: "Hair & Makeup",
    },
    {
      value: "photobooths",
      label: "PhotoBooths",
    },
    {
      value: "photography and videography",
      label: "Photography & Videography",
    },
    {
      value: "printing",
      label: "Printing",
    },
    {
      value: "production management",
      label: "Production Management",
    },
    {
      value: "restaurant",
      label: "Restaurant",
    },
    {
      value: "special fx",
      label: "Special FX",
    },
    {
      value: "staffing",
      label: "Staffing",
    },
    {
      value: "tech solution",
      label: "Tech Solution",
    },
    {
      value: "transport car rentals",
      label: "Transport / Car Rentals",
    },
    {
      value: "wedding invitations einvite",
      label: "Wedding Invitations / E-invite",
    },
    {
      value: "other",
      label: "Other",
    },
  ],
};

export const existingOrganizations = [
  {
    id: 21,
    name: "Expedia Group",
    type: [
      {
        value: "representation_company",
        label: "Representation Company",
      },
    ],
    size: "10000+",
    verified: true,
    website: "https://hilton.com",
    socialMedia: "https://linkedin.com/company/hilton",
    city: "Mumbai",
    country: "India",
    role: "seller",
    members: [
      {
        id: 1,
        name: "Raj Mehta",
        email: "raj.mehta@expedia.com",
        role: "admin",
        designation: "Head of Sales",
      },
      {
        id: 2,
        name: "Neha Kapoor",
        email: "neha.kapoor@expedia.com",
        role: "member",
        designation: "Account Manager",
      },
    ],
  },
  {
    id: 22,
    name: "Booking Holdings",
    type: [
      { value: "corporate", label: "Corporate" },
      { value: "event_planner", label: "Event Planner" },
    ],
    size: "5000-10000",
    verified: true,
    website: "https://hilton.com",
    socialMedia: "https://linkedin.com/company/hilton",
    city: "Mumbai",
    country: "India",
    role: "buyer",
    members: [
      {
        id: 3,
        name: "Amit Sharma",
        email: "amit.sharma@booking.com",
        role: "admin",
        designation: "Director of Procurement",
      },
      {
        id: 4,
        name: "Sneha Rathi",
        email: "sneha.rathi@booking.com",
        role: "member",
        designation: "Travel Manager",
      },
    ],
  },
  {
    id: 33,
    name: "American Express Global Business Travel",
    type: [{ value: "travel_house", label: "Travel House" }],
    size: "1000-5000",
    verified: true,
    website: "https://hilton.com",
    socialMedia: "https://linkedin.com/company/hilton",
    city: "Mumbai",
    country: "India",
    role: "buyer",
    members: [
      {
        id: 5,
        name: "Karan Verma",
        email: "karan.verma@amexgbs.com",
        role: "admin",
        designation: "Operations Lead",
      },
      {
        id: 6,
        name: "Priya Desai",
        email: "priya.desai@amexgbs.com",
        role: "member",
        designation: "Travel Analyst",
      },
    ],
  },
  {
    id: 44,
    name: "Marriott International",
    type: [
      {
        value: "hospitality_group",
        label: "Hospitality Group",
      },
    ],
    size: "10000+",
    verified: true,
    website: "https://hilton.com",
    socialMedia: "https://linkedin.com/company/hilton",
    city: "Mumbai",
    country: "India",
    role: "seller",
    members: [
      {
        id: 7,
        name: "Anita Rao",
        email: "anita.rao@marriott.com",
        role: "admin",
        designation: "Regional Director",
      },
      {
        id: 8,
        name: "Deepak Nair",
        email: "deepak.nair@marriott.com",
        role: "member",
        designation: "Sales Executive",
      },
    ],
  },
  {
    id: 55,
    name: "Hilton Worldwide",
    type: [
      {
        value: "attraction",
        label: "Attraction",
      },
    ],
    size: "10000+",
    verified: true,
    website: "https://hilton.com",
    socialMedia: "https://linkedin.com/company/hilton",
    city: "Mumbai",
    country: "India",
    role: "seller",
    members: [
      {
        id: 9,
        name: "Ritika Singh",
        email: "ritika.singh@hilton.com",
        role: "admin",
        designation: "General Manager",
      },
      {
        id: 10,
        name: "Vivek Sinha",
        email: "vivek.sinha@hilton.com",
        role: "member",
        designation: "Marketing Manager",
      },
    ],
  },
  {
    id: 66,
    name: "TUI Group",
    type: [
      {
        value: "representation_company",
        label: "Representation Company",
      },
    ],
    size: "5000-10000",
    verified: true,
    website: "https://hilton.com",
    socialMedia: "https://linkedin.com/company/hilton",
    city: "Mumbai",
    country: "India",
    role: "buyer",
    members: [
      {
        id: 11,
        name: "Meera Joshi",
        email: "meera.joshi@tui.com",
        role: "admin",
        designation: "Event Director",
      },
      {
        id: 12,
        name: "Anuj Patil",
        email: "anuj.patil@tui.com",
        role: "member",
        designation: "Coordinator",
      },
    ],
  },
  {
    id: 77,
    name: "Sparkle Events",
    type: [
      {
        value: "wedding_social_event_planner",
        label: "Wedding Planner/ Social Events Planner",
      },
    ],
    size: "5000-10000",
    verified: true,
    website: "https://sparkleevent.com",
    socialMedia: "https://sparkleevent.com/company/hilton",
    city: "Mumbai",
    country: "India",
    role: "buyer",
    members: [
      {
        id: 13,
        name: "Sonali Deshpande",
        email: "sonali@sparkleevent.com",
        role: "admin",
        designation: "Founder",
      },
      {
        id: 14,
        name: "Ravi Khanna",
        email: "ravi@sparkleevent.com",
        role: "member",
        designation: "Event Manager",
      },
    ],
  },
  {
    id: 88,
    name: "EcoStyle Apparel",
    type: [{ value: "incentive_house", label: "Incentive House" }],
    size: "5000-10000",
    verified: true,
    website: "https://creativeagency.com",
    socialMedia: "https://creativeagency.com/company/hilton",
    city: "Mumbai",
    country: "India",
    role: "buyer",
    members: [
      {
        id: 15,
        name: "Nisha Agarwal",
        email: "nisha@ecostyle.com",
        role: "admin",
        designation: "Brand Director",
      },
      {
        id: 16,
        name: "Yusuf Khan",
        email: "yusuf@ecostyle.com",
        role: "member",
        designation: "Event Coordinator",
      },
    ],
  },
];

export const mockBuyers = [
  {
    id: 1,
    type: "buyer",
    categories: ["Event Planner", "Wedding Planner"],
    firstName: "Priya",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Rana",
    gender: "female",
    designation: "Founder",
    email: "priya@sparkleevents.in",
    mobile: "9911223344",
    countryCode: "+91",
    city: "Delhi",
    country: "India",
    website: "https://www.sparkleevents.in",
    joiningDate: randomJoiningDate(),
    company: {
      id: 1,
      name: "Sparkle Events",
      organizationType: "Buyer",
      supplierCategory: "", // Not applicable for buyers
      size: "", // You can populate size if available
      city: "Delhi",
      country: "India",
      website: "https://www.sparkleevents.in",
      socialMedia: "", // You can populate actual links if available
    },
  },
  {
    id: 2,
    type: "buyer",
    categories: ["Event Planner", "Wedding Planner"],
    firstName: "Priya",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Rana",
    gender: "female",
    designation: "Founder",
    email: "priya@sparkleevents.in",
    mobile: "9911223344",
    countryCode: "+91",
    city: "Delhi",
    country: "India",
    website: "https://www.sparkleevents.in",
    joiningDate: randomJoiningDate(),
    company: {
      id: 1,
      name: "Sparkle Events",
      organizationType: "Buyer",
      supplierCategory: "", // Not applicable for buyers
      size: "", // You can populate size if available
      city: "Delhi",
      country: "India",
      website: "https://www.sparkleevents.in",
      socialMedia: "", // You can populate actual links if available
    },
  },
  {
    id: 3,
    type: "buyer",
    categories: ["Event Planner", "Wedding Planner"],
    firstName: "Priya",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Rana",
    gender: "female",
    designation: "Founder",
    email: "priya@sparkleevents.in",
    mobile: "9911223344",
    countryCode: "+91",
    city: "Delhi",
    country: "India",
    website: "https://www.sparkleevents.in",
    joiningDate: randomJoiningDate(),
    company: {
      id: 1,
      name: "Sparkle Events",
      organizationType: "Buyer",
      supplierCategory: "", // Not applicable for buyers
      size: "", // You can populate size if available
      city: "Delhi",
      country: "India",
      website: "https://www.sparkleevents.in",
      socialMedia: "", // You can populate actual links if available
    },
  },
  {
    id: 4,
    type: "buyer",
    categories: ["Event Planner", "Wedding Planner"],
    firstName: "Priya",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Rana",
    gender: "female",
    designation: "Founder",
    email: "priya@sparkleevents.in",
    mobile: "9911223344",
    countryCode: "+91",
    city: "Delhi",
    country: "India",
    website: "https://www.sparkleevents.in",
    joiningDate: randomJoiningDate(),
    company: {
      id: 1,
      name: "Sparkle Events",
      organizationType: "Buyer",
      supplierCategory: "", // Not applicable for buyers
      size: "", // You can populate size if available
      city: "Delhi",
      country: "India",
      website: "https://www.sparkleevents.in",
      socialMedia: "", // You can populate actual links if available
    },
  },
  {
    id: 5,
    type: "buyer",
    categories: ["Corporate"],
    firstName: "Vivek",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Malhotra",
    gender: "male",
    designation: "Admin Lead",
    email: "vivek@techcore.com",
    mobile: "9888877665",
    countryCode: "+91",
    city: "Mumbai",
    country: "India",
    website: "https://www.techcore.com",
    joiningDate: randomJoiningDate(),
    company: {
      id: 1,
      name: "Sparkle Events",
      organizationType: "Buyer",
      supplierCategory: "", // Not applicable for buyers
      size: "", // You can populate size if available
      city: "Delhi",
      country: "India",
      website: "https://www.sparkleevents.in",
      socialMedia: "", // You can populate actual links if available
    },
  },
  {
    id: 6,
    type: "buyer",
    categories: ["Professional Conference Organiser", "Incentive House"],
    firstName: "Aarti",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Joshi",
    gender: "female",
    designation: "Project Director",
    email: "aarti@meetxglobal.com",
    mobile: "9876567890",
    countryCode: "+91",
    city: "Bengaluru",
    country: "India",
    website: "https://www.meetxglobal.com",
    joiningDate: randomJoiningDate(),
    company: {
      id: 1,
      name: "Sparkle Events",
      organizationType: "Buyer",
      supplierCategory: "", // Not applicable for buyers
      size: "", // You can populate size if available
      city: "Delhi",
      country: "India",
      website: "https://www.sparkleevents.in",
      socialMedia: "", // You can populate actual links if available
    },
  },
  {
    id: 7,
    type: "buyer",
    categories: ["Travel House"],
    firstName: "Manoj",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Verma",
    gender: "male",
    designation: "Founder",
    email: "manoj@explorego.in",
    mobile: "9900990099",
    countryCode: "+91",
    city: "Pune",
    country: "India",
    website: "https://www.explorego.in",
    joiningDate: randomJoiningDate(),
    company: {
      id: 1,
      name: "Sparkle Events",
      organizationType: "Buyer",
      supplierCategory: "", // Not applicable for buyers
      size: "", // You can populate size if available
      city: "Delhi",
      country: "India",
      website: "https://www.sparkleevents.in",
      socialMedia: "", // You can populate actual links if available
    },
  },
  {
    id: 8,
    type: "buyer",
    categories: ["Wedding Planner"],
    firstName: "Sana",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Mirza",
    gender: "female",
    designation: "Lead Coordinator",
    email: "sana@shubhvivaah.in",
    mobile: "9845123456",
    countryCode: "+91",
    city: "Lucknow",
    country: "India",
    website: "https://www.shubhvivaah.in",
    joiningDate: randomJoiningDate(),
    company: {
      id: 1,
      name: "Sparkle Events",
      organizationType: "Buyer",
      supplierCategory: "", // Not applicable for buyers
      size: "", // You can populate size if available
      city: "Delhi",
      country: "India",
      website: "https://www.sparkleevents.in",
      socialMedia: "", // You can populate actual links if available
    },
  },
  {
    id: 9,
    type: "buyer",
    categories: ["Association"],
    firstName: "Dr. Kunal",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Sharma",
    gender: "male",
    designation: "Secretary",
    email: "kunal@ida.org",
    mobile: "9922113344",
    countryCode: "+91",
    city: "Nagpur",
    country: "India",
    website: "https://www.ida.org",
    joiningDate: randomJoiningDate(),
    company: {
      id: 1,
      name: "Sparkle Events",
      organizationType: "Buyer",
      supplierCategory: "", // Not applicable for buyers
      size: "", // You can populate size if available
      city: "Delhi",
      country: "India",
      website: "https://www.sparkleevents.in",
      socialMedia: "", // You can populate actual links if available
    },
  },
  {
    id: 10,
    type: "buyer",
    categories: ["Corporate", "Event Planner"],
    firstName: "Geeta",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Raj",
    gender: "female",
    designation: "HR Admin",
    email: "geeta@infinitytech.com",
    mobile: "9876001234",
    countryCode: "+91",
    city: "Chandigarh",
    country: "India",
    website: "https://www.infinitytech.com",
    joiningDate: randomJoiningDate(),
    company: {
      id: 1,
      name: "Sparkle Events",
      organizationType: "Buyer",
      supplierCategory: "", // Not applicable for buyers
      size: "", // You can populate size if available
      city: "Delhi",
      country: "India",
      website: "https://www.sparkleevents.in",
      socialMedia: "", // You can populate actual links if available
    },
  },
  {
    id: 11,
    type: "buyer",
    categories: ["Professional Conference Organiser"],
    firstName: "Tarun",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Kapoor",
    gender: "male",
    designation: "Senior Manager",
    email: "tarun@summitbridge.com",
    mobile: "9812345678",
    countryCode: "+91",
    city: "Jaipur",
    country: "India",
    website: "https://www.summitbridge.com",
    joiningDate: randomJoiningDate(),
    company: {
      id: 1,
      name: "Sparkle Events",
      organizationType: "Buyer",
      supplierCategory: "", // Not applicable for buyers
      size: "", // You can populate size if available
      city: "Delhi",
      country: "India",
      website: "https://www.sparkleevents.in",
      socialMedia: "", // You can populate actual links if available
    },
  },
  {
    id: 12,
    type: "buyer",
    categories: ["Incentive House", "Travel House"],
    firstName: "Ankita",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Saxena",
    gender: "female",
    designation: "Operations Head",
    email: "ankita@holidaygalleria.com",
    mobile: "9856565656",
    countryCode: "+91",
    city: "Surat",
    country: "India",
    website: "https://www.holidaygalleria.com",
    joiningDate: randomJoiningDate(),
    company: {
      id: 1,
      name: "Sparkle Events",
      organizationType: "Buyer",
      supplierCategory: "", // Not applicable for buyers
      size: "", // You can populate size if available
      city: "Delhi",
      country: "India",
      website: "https://www.sparkleevents.in",
      socialMedia: "", // You can populate actual links if available
    },
  },
  {
    id: 13,
    type: "buyer",
    categories: ["Event Planner", "Association"],
    firstName: "Neeraj",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Singh",
    gender: "male",
    designation: "Coordinator",
    email: "neeraj@efg.org",
    mobile: "9822334455",
    countryCode: "+91",
    city: "Bhopal",
    country: "India",
    website: "https://www.efg.org",
    joiningDate: randomJoiningDate(),
    company: {
      id: 1,
      name: "Sparkle Events",
      organizationType: "Buyer",
      supplierCategory: "", // Not applicable for buyers
      size: "", // You can populate size if available
      city: "Delhi",
      country: "India",
      website: "https://www.sparkleevents.in",
      socialMedia: "", // You can populate actual links if available
    },
  },
  {
    id: 14,
    type: "buyer",
    categories: ["Event Planner", "Wedding Planner"],
    firstName: "Priya",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Rana",
    gender: "female",
    designation: "Founder",
    email: "priya@sparkleevents.in",
    mobile: "9911223344",
    countryCode: "+91",
    city: "Delhi",
    country: "India",
    website: "https://www.sparkleevents.in",
    joiningDate: randomJoiningDate(),
    company: {
      id: 1,
      name: "Sparkle Events",
      organizationType: "Buyer",
      supplierCategory: "", // Not applicable for buyers
      size: "", // You can populate size if available
      city: "Delhi",
      country: "India",
      website: "https://www.sparkleevents.in",
      socialMedia: "", // You can populate actual links if available
    },
  },
  {
    id: 15,
    type: "buyer",
    categories: ["Event Planner", "Wedding Planner"],
    firstName: "Priya",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Rana",
    gender: "female",
    designation: "Founder",
    email: "priya@sparkleevents.in",
    mobile: "9911223344",
    countryCode: "+91",
    city: "Delhi",
    country: "India",
    website: "https://www.sparkleevents.in",
    joiningDate: randomJoiningDate(),
    company: {
      id: 1,
      name: "Sparkle Events",
      organizationType: "Buyer",
      supplierCategory: "", // Not applicable for buyers
      size: "", // You can populate size if available
      city: "Delhi",
      country: "India",
      website: "https://www.sparkleevents.in",
      socialMedia: "", // You can populate actual links if available
    },
  },
  {
    id: 16,
    type: "buyer",
    categories: ["Event Planner", "Wedding Planner"],
    firstName: "Priya",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Rana",
    gender: "female",
    designation: "Founder",
    email: "priya@sparkleevents.in",
    mobile: "9911223344",
    countryCode: "+91",
    city: "Delhi",
    country: "India",
    website: "https://www.sparkleevents.in",
    joiningDate: randomJoiningDate(),
    company: {
      id: 1,
      name: "Sparkle Events",
      organizationType: "Buyer",
      supplierCategory: "", // Not applicable for buyers
      size: "", // You can populate size if available
      city: "Delhi",
      country: "India",
      website: "https://www.sparkleevents.in",
      socialMedia: "", // You can populate actual links if available
    },
  },
  {
    id: 17,
    type: "buyer",
    categories: ["Event Planner", "Wedding Planner"],
    firstName: "Priya",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Rana",
    gender: "female",
    designation: "Founder",
    email: "priya@sparkleevents.in",
    mobile: "9911223344",
    countryCode: "+91",
    city: "Delhi",
    country: "India",
    website: "https://www.sparkleevents.in",
    joiningDate: randomJoiningDate(),
    company: {
      id: 1,
      name: "Sparkle Events",
      organizationType: "Buyer",
      supplierCategory: "", // Not applicable for buyers
      size: "", // You can populate size if available
      city: "Delhi",
      country: "India",
      website: "https://www.sparkleevents.in",
      socialMedia: "", // You can populate actual links if available
    },
  },
  {
    id: 18,
    type: "buyer",
    categories: ["Corporate"],
    firstName: "Vivek",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Malhotra",
    gender: "male",
    designation: "Admin Lead",
    email: "vivek@techcore.com",
    mobile: "9888877665",
    countryCode: "+91",
    city: "Mumbai",
    country: "India",
    website: "https://www.techcore.com",
    joiningDate: randomJoiningDate(),
    company: {
      id: 1,
      name: "Sparkle Events",
      organizationType: "Buyer",
      supplierCategory: "", // Not applicable for buyers
      size: "", // You can populate size if available
      city: "Delhi",
      country: "India",
      website: "https://www.sparkleevents.in",
      socialMedia: "", // You can populate actual links if available
    },
  },
  {
    id: 19,
    type: "buyer",
    categories: ["Professional Conference Organiser", "Incentive House"],
    firstName: "Aarti",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Joshi",
    gender: "female",
    designation: "Project Director",
    email: "aarti@meetxglobal.com",
    mobile: "9876567890",
    countryCode: "+91",
    city: "Bengaluru",
    country: "India",
    website: "https://www.meetxglobal.com",
    joiningDate: randomJoiningDate(),
    company: {
      id: 1,
      name: "Sparkle Events",
      organizationType: "Buyer",
      supplierCategory: "", // Not applicable for buyers
      size: "", // You can populate size if available
      city: "Delhi",
      country: "India",
      website: "https://www.sparkleevents.in",
      socialMedia: "", // You can populate actual links if available
    },
  },
  {
    id: 20,
    type: "buyer",
    categories: ["Travel House"],
    firstName: "Manoj",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Verma",
    gender: "male",
    designation: "Founder",
    email: "manoj@explorego.in",
    mobile: "9900990099",
    countryCode: "+91",
    city: "Pune",
    country: "India",
    website: "https://www.explorego.in",
    joiningDate: randomJoiningDate(),
    company: {
      id: 1,
      name: "Sparkle Events",
      organizationType: "Buyer",
      supplierCategory: "", // Not applicable for buyers
      size: "", // You can populate size if available
      city: "Delhi",
      country: "India",
      website: "https://www.sparkleevents.in",
      socialMedia: "", // You can populate actual links if available
    },
  },
  {
    id: 21,
    type: "buyer",
    categories: ["Wedding Planner"],
    firstName: "Sana",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Mirza",
    gender: "female",
    designation: "Lead Coordinator",
    email: "sana@shubhvivaah.in",
    mobile: "9845123456",
    countryCode: "+91",
    city: "Lucknow",
    country: "India",
    website: "https://www.shubhvivaah.in",
    joiningDate: randomJoiningDate(),
    company: {
      id: 1,
      name: "Sparkle Events",
      organizationType: "Buyer",
      supplierCategory: "", // Not applicable for buyers
      size: "", // You can populate size if available
      city: "Delhi",
      country: "India",
      website: "https://www.sparkleevents.in",
      socialMedia: "", // You can populate actual links if available
    },
  },
  {
    id: 22,
    type: "buyer",
    categories: ["Association"],
    firstName: "Dr. Kunal",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Sharma",
    gender: "male",
    designation: "Secretary",
    email: "kunal@ida.org",
    mobile: "9922113344",
    countryCode: "+91",
    city: "Nagpur",
    country: "India",
    website: "https://www.ida.org",
    joiningDate: randomJoiningDate(),
    company: {
      id: 1,
      name: "Sparkle Events",
      organizationType: "Buyer",
      supplierCategory: "", // Not applicable for buyers
      size: "", // You can populate size if available
      city: "Delhi",
      country: "India",
      website: "https://www.sparkleevents.in",
      socialMedia: "", // You can populate actual links if available
    },
  },
  {
    id: 23,
    type: "buyer",
    categories: ["Corporate", "Event Planner"],
    firstName: "Geeta",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Raj",
    gender: "female",
    designation: "HR Admin",
    email: "geeta@infinitytech.com",
    mobile: "9876001234",
    countryCode: "+91",
    city: "Chandigarh",
    country: "India",
    website: "https://www.infinitytech.com",
    joiningDate: randomJoiningDate(),
    company: {
      id: 1,
      name: "Sparkle Events",
      organizationType: "Buyer",
      supplierCategory: "", // Not applicable for buyers
      size: "", // You can populate size if available
      city: "Delhi",
      country: "India",
      website: "https://www.sparkleevents.in",
      socialMedia: "", // You can populate actual links if available
    },
  },
  {
    id: 24,
    type: "buyer",
    categories: ["Professional Conference Organiser"],
    firstName: "Tarun",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Kapoor",
    gender: "male",
    designation: "Senior Manager",
    email: "tarun@summitbridge.com",
    mobile: "9812345678",
    countryCode: "+91",
    city: "Jaipur",
    country: "India",
    website: "https://www.summitbridge.com",
    joiningDate: randomJoiningDate(),
    company: {
      id: 1,
      name: "Sparkle Events",
      organizationType: "Buyer",
      supplierCategory: "", // Not applicable for buyers
      size: "", // You can populate size if available
      city: "Delhi",
      country: "India",
      website: "https://www.sparkleevents.in",
      socialMedia: "", // You can populate actual links if available
    },
  },
  {
    id: 25,
    type: "buyer",
    categories: ["Incentive House", "Travel House"],
    firstName: "Ankita",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Saxena",
    gender: "female",
    designation: "Operations Head",
    email: "ankita@holidaygalleria.com",
    mobile: "9856565656",
    countryCode: "+91",
    city: "Surat",
    country: "India",
    website: "https://www.holidaygalleria.com",
    joiningDate: randomJoiningDate(),
    company: {
      id: 1,
      name: "Sparkle Events",
      organizationType: "Buyer",
      supplierCategory: "", // Not applicable for buyers
      size: "", // You can populate size if available
      city: "Delhi",
      country: "India",
      website: "https://www.sparkleevents.in",
      socialMedia: "", // You can populate actual links if available
    },
  },
  {
    id: 26,
    type: "buyer",
    categories: ["Event Planner", "Association"],
    firstName: "Neeraj",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Singh",
    gender: "male",
    designation: "Coordinator",
    email: "neeraj@efg.org",
    mobile: "9822334455",
    countryCode: "+91",
    city: "Bhopal",
    country: "India",
    website: "https://www.efg.org",
    joiningDate: randomJoiningDate(),
    company: {
      id: 1,
      name: "Sparkle Events",
      organizationType: "Buyer",
      supplierCategory: "", // Not applicable for buyers
      size: "", // You can populate size if available
      city: "Delhi",
      country: "India",
      website: "https://www.sparkleevents.in",
      socialMedia: "", // You can populate actual links if available
    },
  },
  {
    id: 27,
    type: "buyer",
    categories: ["Event Planner", "Wedding Planner"],
    firstName: "Priya",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Rana",
    gender: "female",
    designation: "Founder",
    email: "priya@sparkleevents.in",
    mobile: "9911223344",
    countryCode: "+91",
    city: "Delhi",
    country: "India",
    website: "https://www.sparkleevents.in",
    joiningDate: randomJoiningDate(),
    company: {
      id: 1,
      name: "Sparkle Events",
      organizationType: "Buyer",
      supplierCategory: "", // Not applicable for buyers
      size: "", // You can populate size if available
      city: "Delhi",
      country: "India",
      website: "https://www.sparkleevents.in",
      socialMedia: "", // You can populate actual links if available
    },
  },
  {
    id: 28,
    type: "buyer",
    categories: ["Event Planner", "Wedding Planner"],
    firstName: "Priya",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Rana",
    gender: "female",
    designation: "Founder",
    email: "priya@sparkleevents.in",
    mobile: "9911223344",
    countryCode: "+91",
    city: "Delhi",
    country: "India",
    website: "https://www.sparkleevents.in",
    joiningDate: randomJoiningDate(),
    company: {
      id: 1,
      name: "Sparkle Events",
      organizationType: "Buyer",
      supplierCategory: "", // Not applicable for buyers
      size: "", // You can populate size if available
      city: "Delhi",
      country: "India",
      website: "https://www.sparkleevents.in",
      socialMedia: "", // You can populate actual links if available
    },
  },
  {
    id: 29,
    type: "buyer",
    categories: ["Event Planner", "Wedding Planner"],
    firstName: "Priya",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Rana",
    gender: "female",
    designation: "Founder",
    email: "priya@sparkleevents.in",
    mobile: "9911223344",
    countryCode: "+91",
    city: "Delhi",
    country: "India",
    website: "https://www.sparkleevents.in",
    joiningDate: randomJoiningDate(),
    company: {
      id: 1,
      name: "Sparkle Events",
      organizationType: "Buyer",
      supplierCategory: "", // Not applicable for buyers
      size: "", // You can populate size if available
      city: "Delhi",
      country: "India",
      website: "https://www.sparkleevents.in",
      socialMedia: "", // You can populate actual links if available
    },
  },
  {
    id: 30,
    type: "buyer",
    categories: ["Event Planner", "Wedding Planner"],
    firstName: "Priya",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Rana",
    gender: "female",
    designation: "Founder",
    email: "priya@sparkleevents.in",
    mobile: "9911223344",
    countryCode: "+91",
    city: "Delhi",
    country: "India",
    website: "https://www.sparkleevents.in",
    joiningDate: randomJoiningDate(),
    company: {
      id: 1,
      name: "Sparkle Events",
      organizationType: "Buyer",
      supplierCategory: "", // Not applicable for buyers
      size: "", // You can populate size if available
      city: "Delhi",
      country: "India",
      website: "https://www.sparkleevents.in",
      socialMedia: "", // You can populate actual links if available
    },
  },
  {
    id: 31,
    type: "buyer",
    categories: ["Corporate"],
    firstName: "Vivek",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Malhotra",
    gender: "male",
    designation: "Admin Lead",
    email: "vivek@techcore.com",
    mobile: "9888877665",
    countryCode: "+91",
    city: "Mumbai",
    country: "India",
    website: "https://www.techcore.com",
    joiningDate: randomJoiningDate(),
    company: {
      id: 1,
      name: "Sparkle Events",
      organizationType: "Buyer",
      supplierCategory: "", // Not applicable for buyers
      size: "", // You can populate size if available
      city: "Delhi",
      country: "India",
      website: "https://www.sparkleevents.in",
      socialMedia: "", // You can populate actual links if available
    },
  },
  {
    id: 32,
    type: "buyer",
    categories: ["Professional Conference Organiser", "Incentive House"],
    firstName: "Aarti",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Joshi",
    gender: "female",
    designation: "Project Director",
    email: "aarti@meetxglobal.com",
    mobile: "9876567890",
    countryCode: "+91",
    city: "Bengaluru",
    country: "India",
    website: "https://www.meetxglobal.com",
    joiningDate: randomJoiningDate(),
    company: {
      id: 1,
      name: "Sparkle Events",
      organizationType: "Buyer",
      supplierCategory: "", // Not applicable for buyers
      size: "", // You can populate size if available
      city: "Delhi",
      country: "India",
      website: "https://www.sparkleevents.in",
      socialMedia: "", // You can populate actual links if available
    },
  },
  {
    id: 33,
    type: "buyer",
    categories: ["Travel House"],
    firstName: "Manoj",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Verma",
    gender: "male",
    designation: "Founder",
    email: "manoj@explorego.in",
    mobile: "9900990099",
    countryCode: "+91",
    city: "Pune",
    country: "India",
    website: "https://www.explorego.in",
    joiningDate: randomJoiningDate(),
    company: {
      id: 1,
      name: "Sparkle Events",
      organizationType: "Buyer",
      supplierCategory: "", // Not applicable for buyers
      size: "", // You can populate size if available
      city: "Delhi",
      country: "India",
      website: "https://www.sparkleevents.in",
      socialMedia: "", // You can populate actual links if available
    },
  },
  {
    id: 34,
    type: "buyer",
    categories: ["Wedding Planner"],
    firstName: "Sana",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Mirza",
    gender: "female",
    designation: "Lead Coordinator",
    email: "sana@shubhvivaah.in",
    mobile: "9845123456",
    countryCode: "+91",
    city: "Lucknow",
    country: "India",
    website: "https://www.shubhvivaah.in",
    joiningDate: randomJoiningDate(),
    company: {
      id: 1,
      name: "Sparkle Events",
      organizationType: "Buyer",
      supplierCategory: "", // Not applicable for buyers
      size: "", // You can populate size if available
      city: "Delhi",
      country: "India",
      website: "https://www.sparkleevents.in",
      socialMedia: "", // You can populate actual links if available
    },
  },
  {
    id: 35,
    type: "buyer",
    categories: ["Association"],
    firstName: "Dr. Kunal",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Sharma",
    gender: "male",
    designation: "Secretary",
    email: "kunal@ida.org",
    mobile: "9922113344",
    countryCode: "+91",
    city: "Nagpur",
    country: "India",
    website: "https://www.ida.org",
    joiningDate: randomJoiningDate(),
    company: {
      id: 1,
      name: "Sparkle Events",
      organizationType: "Buyer",
      supplierCategory: "", // Not applicable for buyers
      size: "", // You can populate size if available
      city: "Delhi",
      country: "India",
      website: "https://www.sparkleevents.in",
      socialMedia: "", // You can populate actual links if available
    },
  },
  {
    id: 36,
    type: "buyer",
    categories: ["Corporate", "Event Planner"],
    firstName: "Geeta",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Raj",
    gender: "female",
    designation: "HR Admin",
    email: "geeta@infinitytech.com",
    mobile: "9876001234",
    countryCode: "+91",
    city: "Chandigarh",
    country: "India",
    website: "https://www.infinitytech.com",
    joiningDate: randomJoiningDate(),
    company: {
      id: 1,
      name: "Sparkle Events",
      organizationType: "Buyer",
      supplierCategory: "", // Not applicable for buyers
      size: "", // You can populate size if available
      city: "Delhi",
      country: "India",
      website: "https://www.sparkleevents.in",
      socialMedia: "", // You can populate actual links if available
    },
  },
  {
    id: 37,
    type: "buyer",
    categories: ["Professional Conference Organiser"],
    firstName: "Tarun",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Kapoor",
    gender: "male",
    designation: "Senior Manager",
    email: "tarun@summitbridge.com",
    mobile: "9812345678",
    countryCode: "+91",
    city: "Jaipur",
    country: "India",
    website: "https://www.summitbridge.com",
    joiningDate: randomJoiningDate(),
    company: {
      id: 1,
      name: "Sparkle Events",
      organizationType: "Buyer",
      supplierCategory: "", // Not applicable for buyers
      size: "", // You can populate size if available
      city: "Delhi",
      country: "India",
      website: "https://www.sparkleevents.in",
      socialMedia: "", // You can populate actual links if available
    },
  },
  {
    id: 38,
    type: "buyer",
    categories: ["Incentive House", "Travel House"],
    firstName: "Ankita",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Saxena",
    gender: "female",
    designation: "Operations Head",
    email: "ankita@holidaygalleria.com",
    mobile: "9856565656",
    countryCode: "+91",
    city: "Surat",
    country: "India",
    website: "https://www.holidaygalleria.com",
    joiningDate: randomJoiningDate(),
    company: {
      id: 1,
      name: "Sparkle Events",
      organizationType: "Buyer",
      supplierCategory: "", // Not applicable for buyers
      size: "", // You can populate size if available
      city: "Delhi",
      country: "India",
      website: "https://www.sparkleevents.in",
      socialMedia: "", // You can populate actual links if available
    },
  },
  {
    id: 39,
    type: "buyer",
    categories: ["Event Planner", "Association"],
    firstName: "Neeraj",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Singh",
    gender: "male",
    designation: "Coordinator",
    email: "neeraj@efg.org",
    mobile: "9822334455",
    countryCode: "+91",
    city: "Bhopal",
    country: "India",
    website: "https://www.efg.org",
    joiningDate: randomJoiningDate(),
    company: {
      id: 1,
      name: "Sparkle Events",
      organizationType: "Buyer",
      supplierCategory: "", // Not applicable for buyers
      size: "", // You can populate size if available
      city: "Delhi",
      country: "India",
      website: "https://www.sparkleevents.in",
      socialMedia: "", // You can populate actual links if available
    },
  },
];

export const mockSellers = [
  {
    id: 1,
    type: "seller",
    category: "Hotel",
    firstName: "Anita",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Mehra",
    gender: "female",
    designation: "Sales Director",
    email: "anita@grandluxe.com",
    mobile: "9876543210",
    countryCode: "+91",
    city: "Mumbai",
    country: "India",
    website: "https://www.grandluxe.com",
    joiningDate: randomJoiningDate(),

    company: {
      id: 2,
      name: "Grand Luxe Hotel",
      organizationType: "Hotel",
      supplierCategory: "Hotel",
      size: "", // Optional field
      city: "Mumbai",
      country: "India",
      website: "https://www.grandluxe.com",
      socialMedia: "",
    },
  },
  {
    id: 2,
    type: "seller",
    category: "Venue",
    firstName: "Ravi",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Patel",
    gender: "male",
    designation: "Event Manager",
    email: "ravi@sunsetgarden.com",
    mobile: "9021345678",
    countryCode: "+91",
    city: "Ahmedabad",
    country: "India",
    website: "https://www.sunsetgarden.com",
    joiningDate: randomJoiningDate(),

    company: {
      id: 2,
      name: "Grand Luxe Hotel",
      organizationType: "Hotel",
      supplierCategory: "Hotel",
      size: "", // Optional field
      city: "Mumbai",
      country: "India",
      website: "https://www.grandluxe.com",
      socialMedia: "",
    },
  },
  {
    id: 3,
    type: "seller",
    category: "Supplier",
    supplierServices: ["Caterers", "Furniture Rental", "Decor"],
    firstName: "Simran",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Kapoor",
    gender: "female",
    designation: "Founder",
    email: "simran@eliteevent.in",
    mobile: "9967001122",
    countryCode: "+91",
    city: "Delhi",
    country: "India",
    website: "https://www.eliteevent.in",
    joiningDate: randomJoiningDate(),

    company: {
      id: 2,
      name: "Grand Luxe Hotel",
      organizationType: "Hotel",
      supplierCategory: "Hotel",
      size: "", // Optional field
      city: "Mumbai",
      country: "India",
      website: "https://www.grandluxe.com",
      socialMedia: "",
    },
  },
  {
    id: 4,
    type: "seller",
    category: "Airline",
    firstName: "Arjun",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Seth",
    gender: "male",
    designation: "Partnership Head",
    email: "arjun@skybound.com",
    mobile: "9888776655",
    countryCode: "+91",
    city: "Bengaluru",
    country: "India",
    website: "https://www.skybound.com",
    joiningDate: randomJoiningDate(),

    company: {
      id: 2,
      name: "Grand Luxe Hotel",
      organizationType: "Hotel",
      supplierCategory: "Hotel",
      size: "", // Optional field
      city: "Mumbai",
      country: "India",
      website: "https://www.grandluxe.com",
      socialMedia: "",
    },
  },
  {
    id: 5,
    type: "seller",
    category: "Convention Center",
    firstName: "Leena",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Naik",
    gender: "female",
    designation: "Venue Manager",
    email: "leena@neoconventions.com",
    mobile: "9090990090",
    countryCode: "+91",
    city: "Hyderabad",
    country: "India",
    website: "https://www.neoconventions.com",
    joiningDate: randomJoiningDate(),

    company: {
      id: 2,
      name: "Grand Luxe Hotel",
      organizationType: "Hotel",
      supplierCategory: "Hotel",
      size: "", // Optional field
      city: "Mumbai",
      country: "India",
      website: "https://www.grandluxe.com",
      socialMedia: "",
    },
  },
  {
    id: 6,
    type: "seller",
    category: "Supplier",
    supplierServices: ["Entertainment", "Dance Choreography", "Special FX"],
    firstName: "Rahul",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Shetty",
    gender: "male",
    designation: "Creative Head",
    email: "rahul@grooveglow.com",
    mobile: "9123456780",
    countryCode: "+91",
    city: "Goa",
    country: "India",
    website: "https://www.grooveglow.com",
    joiningDate: randomJoiningDate(),

    company: {
      id: 2,
      name: "Grand Luxe Hotel",
      organizationType: "Hotel",
      supplierCategory: "Hotel",
      size: "", // Optional field
      city: "Mumbai",
      country: "India",
      website: "https://www.grandluxe.com",
      socialMedia: "",
    },
  },
  {
    id: 7,
    type: "seller",
    category: "Tourism Board",
    firstName: "Ananya",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Menon",
    gender: "female",
    designation: "Tourism Officer",
    email: "ananya@visitkerala.org",
    mobile: "9999999999",
    countryCode: "+91",
    city: "Kochi",
    country: "India",
    website: "https://www.visitkerala.org",
    joiningDate: randomJoiningDate(),

    company: {
      id: 2,
      name: "Grand Luxe Hotel",
      organizationType: "Hotel",
      supplierCategory: "Hotel",
      size: "", // Optional field
      city: "Mumbai",
      country: "India",
      website: "https://www.grandluxe.com",
      socialMedia: "",
    },
  },
  {
    id: 8,
    type: "seller",
    category: "Supplier",
    supplierServices: ["Other"],
    otherServiceDescription: "Drone videography and aerial mapping",
    firstName: "Kabir",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Shah",
    gender: "male",
    designation: "Founder",
    email: "kabir@skyframe.in",
    mobile: "9944556677",
    countryCode: "+91",
    city: "Pune",
    country: "India",
    website: "https://www.skyframe.in",
    joiningDate: randomJoiningDate(),

    company: {
      id: 2,
      name: "Grand Luxe Hotel",
      organizationType: "Hotel",
      supplierCategory: "Hotel",
      size: "", // Optional field
      city: "Mumbai",
      country: "India",
      website: "https://www.grandluxe.com",
      socialMedia: "",
    },
  },
  {
    id: 9,
    type: "seller",
    category: "Hospitality Group",
    firstName: "Fatima",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Khan",
    gender: "female",
    designation: "Group Marketing Lead",
    email: "fatima@harmonystays.com",
    mobile: "9000004444",
    countryCode: "+91",
    city: "Udaipur",
    country: "India",
    website: "https://www.harmonystays.com",
    joiningDate: randomJoiningDate(),

    company: {
      id: 2,
      name: "Grand Luxe Hotel",
      organizationType: "Hotel",
      supplierCategory: "Hotel",
      size: "", // Optional field
      city: "Mumbai",
      country: "India",
      website: "https://www.grandluxe.com",
      socialMedia: "",
    },
  },
  {
    id: 10,
    type: "seller",
    category: "Representation Company",

    firstName: "Nikhil",
    mockPastInteractionsUsers: [
      {
        date: "2024-12-15",
        action: "Attended Virtual FAM Trip",
        notes: "User participated actively and shared valuable feedback.",
      },
      {
        date: "2025-03-04",
        action: "Meeting Scheduled",
        notes: "Had a 1-on-1 meeting with Global MICE Connect.",
      },
      {
        date: "2025-05-10",
        action: "Document Submitted",
        notes: "Uploaded required certifications and verified details.",
      },
      {
        date: "2025-06-27",
        action: "Feedback Received",
        notes: "Received positive ratings from multiple sellers.",
      },
    ],
    lastName: "Deshmukh",
    gender: "male",
    designation: "Business Head",
    email: "nikhil@globalmice.com",
    mobile: "9988776655",
    countryCode: "+91",
    city: "Chennai",
    country: "India",
    website: "https://www.globalmice.com",
    joiningDate: randomJoiningDate(),

    company: {
      id: 2,
      name: "Grand Luxe Hotel",
      organizationType: "Hotel",
      supplierCategory: "Hotel",
      size: "", // Optional field
      city: "Mumbai",
      country: "India",
      website: "https://www.grandluxe.com",
      socialMedia: "",
    },
  },
];

export const countryCodes = [
  { label: "+1 ", value: "+1", length: 10 },
  { label: "+91 ", value: "+91", length: 10 },
  { label: "+44 ", value: "+44", length: 10 },
  { label: "+61 ", value: "+61", length: 9 },
  { label: "+81 ", value: "+81", length: 10 },
  { label: "+971 ", value: "+971", length: 9 },
  { label: "+33 ", value: "+33", length: 9 },
  { label: "+49 ", value: "+49", length: 10 },
  { label: "+86 ", value: "+86", length: 11 },
  { label: "+1 ", value: "+1-ca", length: 10 },
];

export const genders = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
  { value: "non_binary", label: "Non Binary" },
  { value: "other", label: "Other" },
];

export const cityCountryMap = {
  "New York": "United States",
  London: "United Kingdom",
  Paris: "France",
  Tokyo: "Japan",
  Mumbai: "India",
  Delhi: "India",
  Sydney: "Australia",
  Toronto: "Canada",
  Dubai: "United Arab Emirates",
};

export const upcomingEvents = [
  {
    id: 1,
    title: "Travel Tech Summit 2024",
    host: {
      name: "Sarah Johnson",
      type: "seller",
    },
    hostId: "user-001",
    description:
      "Annual conference bringing together travel technology leaders and innovators from around the world.",
    date: "2024-07-20",
    startTime: "09:00",
    endTime: "18:00",
    location: "Singapore Convention Centre",
    attendees: 450,
    status: "upcoming",
    image:
      "https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=300&h=200&fit=crop",
    meetings: [
      { id: 1, participant: "Michael Chen", time: "10:30" },
      { id: 2, participant: "Emma Rodriguez", time: "14:00" },
      { id: 3, participant: "David Kim", time: "16:30" },
    ],
  },
  {
    id: 2,
    title: "B2B Travel Expo",
    host: {
      name: "Admin Team",
      type: "admin",
    },
    hostId: "admin-001",
    type: "Virtual Event",
    description:
      "Premier B2B travel trade show connecting buyers and sellers in the travel industry.",
    date: "2024-07-25",
    startTime: "10:00",
    endTime: "17:00",
    location: "London ExCeL",
    attendees: 320,
    status: "live",
    image:
      "https://images.unsplash.com/photo-1511578314322-379afb476865?w=300&h=200&fit=crop",
    meetings: [
      { id: 4, participant: "Sophie Laurent", time: "11:00" },
      { id: 5, participant: "James Wilson", time: "15:30" },
    ],
  },

  {
    id: 3,
    title: "Hospitality Connect 2024",
    host: {
      name: "Emma Rodriguez",
      type: "seller",
    },
    hostId: "user-002",
    type: "In-person Conference",
    description:
      "Networking event for hospitality professionals and service providers.",
    date: "2024-08-05",
    startTime: "08:30",
    endTime: "19:00",
    location: "Miami Beach Convention Center",
    attendees: 280,
    status: "upcoming",
    image:
      "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=300&h=200&fit=crop",
    meetings: [
      { id: 6, participant: "Maria Santos", time: "09:15" },
      { id: 7, participant: "Carlos Rodriguez", time: "13:45" },
    ],
  },
];

export const adminQuickStats = [
  {
    label: "Total Users",
    value: "120",
    subcounts: [
      { label: "Buyers", value: 60, color: "text-blue-600" },
      { label: "Sellers", value: 60, color: "text-green-600" },
    ],
    trend: "up",
    icon: "Users",
    url: "/users",
  },
  {
    label: "Pending Approvals",
    value: "15",
    trend: "down",
    icon: "Clock",
    url: "/approvals",
  },
  {
    label: "Upcoming Events",
    value: "4",
    trend: "up",
    icon: "CalendarClock",
    url: "/events",
  },
  {
    label: "Total Events",
    value: "10",
    trend: "up",
    icon: "Calendar",
    url: "/events",
  },
  {
    label: "Total Organisations",
    value: "25",
    subcounts: [
      { label: "Buyer Orgs", value: 13, color: "text-blue-600" },
      { label: "Seller Orgs", value: 12, color: "text-green-600" },
    ],
    trend: "up",
    icon: "Building2",
    url: "/organizations",
  },
];

export const quickStats = [
  {
    label: "Upcoming Events",
    value: "3",
    change: "",
    trend: "up",
    icon: "Calendar",
  },
  {
    label: "Contacts",
    value: "8",
    change: "",
    trend: "up",
    icon: "Users",
  },
  // {
  //   label: "Business Activities",
  //   value: "34",
  //   change: "",
  //   trend: "up",
  //   icon: "Activity",
  // },
  // {
  //   label: "Connections Made",
  //   value: "56",
  //   change: "",
  //   trend: "up",
  //   icon: "UserPlus",
  // },
];

export const approvalsData = [
  {
    id: 5,
    type: "user_registration",
    title: "New Buyer Registration",
    description: "Priya Rana from Sparkle Events",
    submittedBy: {
      firstName: "Priya",
      lastName: "Rana",
      email: "priya@sparkleevents.in",
      avatar:
        "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=150&h=150&fit=crop&crop=face",
      company: "Sparkle Events",
      role: "Buyer",
      designation: "Founder",
      mobile: "9911223344",
      countryCode: "+91",
      city: "Delhi",
      country: "India",
      website: "https://www.sparkleevents.in",
      categories: ["Event Planner", "Wedding Planner"],
      joiningDate: "2023-05-12", // example fixed date
      mockPastInteractionsUsers: [
        {
          date: "2024-12-15",
          action: "Attended Virtual FAM Trip",
          notes: "User participated actively and shared valuable feedback.",
        },
        {
          date: "2025-03-04",
          action: "Meeting Scheduled",
          notes: "Had a 1-on-1 meeting with Global MICE Connect.",
        },
        {
          date: "2025-05-10",
          action: "Document Submitted",
          notes: "Uploaded required certifications and verified details.",
        },
        {
          date: "2025-06-27",
          action: "Feedback Received",
          notes: "Received positive ratings from multiple sellers.",
        },
      ],
    },
    submittedAt: new Date(Date.now() - 1800000),
    priority: "high",
    status: "pending",
  },
  {
    id: 6,
    type: "user_registration",
    title: "New Seller Registration",
    description: "John Doe from Creative Designs",
    submittedBy: {
      firstName: "John",
      lastName: "Doe",
      email: "john@creativedesigns.com",
      avatar:
        "https://images.unsplash.com/photo-1495952727624-df4f02dbad69?w=150&h=150&fit=crop&crop=face",
      company: "Creative Designs",
      role: "Seller",
      designation: "CEO",
      mobile: "9888776655",
      countryCode: "+1",
      city: "New York",
      country: "USA",
      website: "https://www.creativedesigns.com",
      categories: ["Interior Design", "Home Decor"],
      joiningDate: "2023-04-15", // example fixed date
      mockPastInteractionsUsers: [
        {
          date: "2024-06-20",
          action: "Attended Design Expo",
          notes: "Showcased new interior design trends.",
        },
        {
          date: "2024-09-10",
          action: "Product Launch",
          notes:
            "Launched new product line in collaboration with local artisans.",
        },
        {
          date: "2025-01-22",
          action: "Meeting Scheduled",
          notes:
            "Had a business development meeting with top furniture manufacturers.",
        },
      ],
    },
    submittedAt: new Date(Date.now() - 3600000),
    priority: "medium",
    status: "approved",
  },
  {
    id: 7,
    type: "user_registration",
    title: "New Buyer Registration",
    description: "Sophia Carter from Luxe Travel",
    submittedBy: {
      firstName: "Sophia",
      lastName: "Carter",
      email: "sophia@luxetravel.com",
      avatar:
        "https://images.unsplash.com/photo-1589927986089-35812388d1d2?w=150&h=150&fit=crop&crop=face",
      company: "Luxe Travel",
      role: "Buyer",
      designation: "Co-Founder",
      mobile: "9456789123",
      countryCode: "+44",
      city: "London",
      country: "UK",
      website: "https://www.luxetravel.com",
      categories: ["Travel Consultant", "Luxury Travel"],
      joiningDate: "2023-07-08", // example fixed date
      mockPastInteractionsUsers: [
        {
          date: "2025-01-18",
          action: "Attended Luxury Travel Forum",
          notes: "Participated in discussions about sustainable travel.",
        },
        {
          date: "2025-02-05",
          action: "Meeting Scheduled",
          notes: "Met with industry leaders at the International Tourism Expo.",
        },
      ],
    },
    submittedAt: new Date(Date.now() - 5400000),
    priority: "low",
    status: "pending",
  },
  {
    id: 8,
    type: "user_registration",
    title: "New Seller Registration",
    description: "Liam Clark from TechGenius",
    submittedBy: {
      firstName: "Liam",
      lastName: "Clark",
      email: "liam@techgenius.com",
      avatar:
        "https://images.unsplash.com/photo-1511466044738-b36a3f1f56e6?w=150&h=150&fit=crop&crop=face",
      company: "TechGenius",
      role: "Seller",
      designation: "Founder",
      mobile: "9123456789",
      countryCode: "+1",
      city: "San Francisco",
      country: "USA",
      website: "https://www.techgenius.com",
      categories: ["Technology", "Software Development"],
      joiningDate: "2023-03-25", // example fixed date
      mockPastInteractionsUsers: [
        {
          date: "2024-09-15",
          action: "Tech Conference Speaker",
          notes: "Spoke about AI advancements at the Global Tech Summit.",
        },
        {
          date: "2025-04-04",
          action: "New Product Launch",
          notes: "Released the latest AI-powered software solution.",
        },
      ],
    },
    submittedAt: new Date(Date.now() - 7200000),
    priority: "high",
    status: "approved",
  },
  {
    id: 9,
    type: "user_registration",
    title: "New Buyer Registration",
    description: "Emma Wilson from EcoStyle Apparel",
    submittedBy: {
      firstName: "Emma",
      lastName: "Wilson",
      email: "emma@ecostyleapparel.com",
      avatar:
        "https://images.unsplash.com/photo-1601954374353-2e5ea1bfe91f?w=150&h=150&fit=crop&crop=face",
      company: "EcoStyle Apparel",
      role: "Buyer",
      designation: "Marketing Director",
      mobile: "9837265412",
      countryCode: "+61",
      city: "Sydney",
      country: "Australia",
      website: "https://www.ecostyleapparel.com",
      categories: ["Eco-Friendly Fashion", "Sustainable Apparel"],
      joiningDate: "2023-06-10", // example fixed date
      mockPastInteractionsUsers: [
        {
          date: "2024-11-03",
          action: "Sustainability Workshop",
          notes: "Facilitated a workshop on sustainable fabric sourcing.",
        },
        {
          date: "2025-02-11",
          action: "Product Collaboration",
          notes: "Partnered with eco-conscious brands for new collection.",
        },
      ],
    },
    submittedAt: new Date(Date.now() - 10800000),
    priority: "medium",
    status: "pending",
  },
  {
    id: 10,
    type: "user_registration",
    title: "New Seller Registration",
    description: "Carlos Vega from Creative Agency",
    submittedBy: {
      firstName: "Carlos",
      lastName: "Vega",
      email: "carlos@creativeagency.com",
      avatar:
        "https://images.unsplash.com/photo-1523497230124-e604e9b92312?w=150&h=150&fit=crop&crop=face",
      company: "Creative Agency",
      role: "Seller",
      designation: "Creative Director",
      mobile: "9944332211",
      countryCode: "+34",
      city: "Barcelona",
      country: "Spain",
      website: "https://www.creativeagency.com",
      categories: ["Digital Marketing", "Branding"],
      joiningDate: "2023-01-20", // example fixed date
      mockPastInteractionsUsers: [
        {
          date: "2024-05-05",
          action: "Branding Campaign Launch",
          notes:
            "Successfully launched a branding campaign for a global tech firm.",
        },
        {
          date: "2025-02-14",
          action: "Client Pitch",
          notes:
            "Presented a pitch for a major fashion brand's digital transformation.",
        },
      ],
    },
    submittedAt: new Date(Date.now() - 12600000),
    priority: "high",
    status: "approved",
  },
];

export const currentUser = {
  id: "user-001",
  name: "Sarah Johnson",
  role: "seller", // Change to "seller" to test seller flow
};

export const contacts = [
  {
    id: 1,
    name: "Michael Rodriguez",
    position: null,
    organization: "Global Travel Solutions",
    categories: ["Event Planner", "Wedding Planner"],
    email: null,
    phone: null,
    city: "New York",
    location: "United States",
    avatar:
      "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
    connectionType: null,
    lastInteraction: null,
    events: [],
    tags: [],
    rating: null,
    status: "available",
    type: "buyer",
    role: "Senior Travel Manager",
    availableSlots: 12,
    timezone: "EST",
    previousMeetings: 3,
    calendars: ["primary"],
    company: {
      id: 2,
      name: "Global Travel Solutions",
      organizationType: "Buyer",
      supplierCategory: "", // Not applicable for buyers
      size: "", // You can populate size if available
      city: "Delhi",
      country: "India",
      website: "https://www.globaltravelsolutions.in",
      socialMedia: "", // You can populate actual links if available
    },
  },
  {
    id: 2,
    name: "Sarah Chen",
    position: null,
    organization: "Luxury Hotels International",
    email: null,
    phone: null,
    location: "London, UK",
    avatar:
      "https://images.unsplash.com/photo-1494790108755-2616b9e0e4d4?w=150&h=150&fit=crop&crop=face",
    connectionType: null,
    lastInteraction: null,
    events: [],
    tags: [],
    rating: null,
    status: "busy",
    type: "exhibitor",
    role: "Business Development Director",
    availableSlots: 8,
    timezone: "GMT",
    previousMeetings: 1,
    calendars: ["primary", "events", "meetings"],
  },
  {
    id: 3,
    name: "David Thompson",
    position: null,
    organization: "Adventure Tours Ltd",
    email: null,
    phone: null,
    location: "Sydney, AU",
    avatar:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
    connectionType: null,
    lastInteraction: null,
    events: [],
    tags: [],
    rating: null,
    status: "available",
    type: "exhibitor",
    role: "Operations Manager",
    availableSlots: 15,
    timezone: "AEST",
    previousMeetings: 0,
    calendars: ["primary", "operations"],
  },
  {
    id: 4,
    name: "Emma Wilson",
    position: null,
    organization: "Corporate Events Pro",
    email: null,
    phone: null,
    location: "Toronto, CA",
    avatar:
      "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
    connectionType: null,
    lastInteraction: null,
    events: [],
    tags: [],
    rating: null,
    status: "available",
    type: "buyer",
    role: "Event Coordinator",
    availableSlots: 10,
    timezone: "EST",
    previousMeetings: 2,
    calendars: ["primary"],
  },
  {
    id: 5,
    name: "James Park",
    position: null,
    organization: "Tech Travel Innovations",
    email: null,
    phone: null,
    location: "San Francisco, CA",
    avatar:
      "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop&crop=face",
    connectionType: null,
    lastInteraction: null,
    events: [],
    tags: [],
    rating: null,
    status: "unavailable",
    type: "speaker",
    role: "Product Manager",
    availableSlots: 5,
    timezone: "PST",
    previousMeetings: 4,
    calendars: ["primary"],
  },
  {
    id: 6,
    name: "Lisa Martinez",
    position: null,
    organization: "Destination Marketing Board",
    email: null,
    phone: null,
    location: "Miami, FL",
    avatar:
      "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face",
    connectionType: null,
    lastInteraction: null,
    events: [],
    tags: [],
    rating: null,
    status: "available",
    type: "sponsor",
    role: "Marketing Director",
    availableSlots: 18,
    timezone: "EST",
    previousMeetings: 1,
    calendars: ["primary", "marketing"],
  },
  {
    id: 7,
    name: "Michael Chen",
    position: "Event Director",
    organization: "Asia Pacific Events",
    email: "michael.chen@apeEvents.com",
    phone: "+65 9123 4567",
    location: "Singapore",
    avatar:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
    connectionType: "colleague",
    lastInteraction: "2024-07-12T14:30:00Z",
    events: ["Travel Tech Summit 2024", "B2B Travel Expo"],
    tags: ["Event Management", "Asia Pacific"],
    rating: 4.8,
    status: "online",
    type: null,
    role: null,
    availableSlots: null,
    timezone: null,
    previousMeetings: null,
    calendars: [],
  },
  {
    id: 8,
    name: "Emma Rodriguez",
    position: "Sales Manager",
    organization: "Luxury Hotels Group",
    email: "emma.rodriguez@luxuryhotels.com",
    phone: "+1 (555) 987-6543",
    location: "Miami, FL",
    avatar:
      "https://images.unsplash.com/photo-1494790108755-2616b9c2e3e0?w=150&h=150&fit=crop&crop=face",
    connectionType: "event",
    lastInteraction: "2024-07-11T09:15:00Z",
    events: ["Hospitality Connect 2024"],
    tags: ["Hotels", "Luxury Travel"],
    rating: 4.9,
    status: "away",
    type: null,
    role: null,
    availableSlots: null,
    timezone: null,
    previousMeetings: null,
    calendars: [],
  },
  {
    id: 9,
    name: "David Kim",
    position: "Travel Consultant",
    organization: "Global DMC Network",
    email: "david.kim@globaldmc.com",
    phone: "+82 10 1234 5678",
    location: "Seoul, South Korea",
    avatar:
      "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
    connectionType: "network",
    lastInteraction: "2024-07-10T16:45:00Z",
    events: ["Asia Travel Forum"],
    tags: ["DMC", "Group Travel"],
    rating: 4.7,
    status: "offline",
    type: null,
    role: null,
    availableSlots: null,
    timezone: null,
    previousMeetings: null,
    calendars: [],
  },
  {
    id: 10,
    name: "Sophie Laurent",
    position: "Marketing Director",
    organization: "European Travel Alliance",
    email: "sophie.laurent@eurotravel.com",
    phone: "+33 1 23 45 67 89",
    location: "Paris, France",
    avatar:
      "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
    connectionType: "colleague",
    lastInteraction: "2024-07-09T11:20:00Z",
    events: ["European Travel Summit"],
    tags: ["Marketing", "Europe"],
    rating: 4.6,
    status: "online",
    type: null,
    role: null,
    availableSlots: null,
    timezone: null,
    previousMeetings: null,
    calendars: [],
  },
];

export const filterOptions = [
  { value: "all", label: "All Contacts" },
  { value: "colleague", label: "Colleagues" },
  { value: "event", label: "Event Connections" },
  { value: "network", label: "Network" },
];

export const sortOptions = [
  { value: "name", label: "Name" },
  { value: "organization", label: "Organization" },
  { value: "lastInteraction", label: "Last Interaction" },
  { value: "rating", label: "Rating" },
];

export const getRoleColor = (role) => {
  switch (role?.toLowerCase()) {
    case "admin":
      return {
        primary: "text-accent-600",
        bg: "bg-accent-50",
        border: "border-accent-200",
        gradient: "from-accent-500 to-accent-700",
      };
    case "buyer":
      return {
        primary: "text-primary-600",
        bg: "bg-primary-50",
        border: "border-primary-200",
        gradient: "from-primary-500 to-primary-700",
      };
    case "seller":
      return {
        primary: "text-secondary-600",
        bg: "bg-secondary-50",
        border: "border-secondary-200",
        gradient: "from-secondary-500 to-secondary-700",
      };
    default:
      return {
        primary: "text-primary-600",
        bg: "bg-primary-50",
        border: "border-primary-200",
        gradient: "from-primary-500 to-primary-700",
      };
  }
};

export const buyerTypeOptions = [
  { value: "travel-agency", label: "Travel Agency" },
  { value: "corporate", label: "Corporate Travel Manager" },
  { value: "event-planner", label: "Event Planner" },
  { value: "mice", label: "MICE Organizer" },
  { value: "tour-operator", label: "Tour Operator" },
  { value: "consultant", label: "Travel Consultant" },
];

export const interestOptions = [
  { value: "hotels", label: "Hotels & Accommodation" },
  { value: "destinations", label: "Destinations" },
  { value: "transportation", label: "Transportation" },
  { value: "activities", label: "Activities & Tours" },
  { value: "venues", label: "Event Venues" },
  { value: "technology", label: "Travel Technology" },
  { value: "services", label: "Travel Services" },
];

export const eventTypes = [
  { value: "conference", label: "Conference" },
  { value: "trade-show", label: "Trade Show" },
  { value: "networking", label: "Networking Event" },
  { value: "workshop", label: "Workshop" },
  { value: "seminar", label: "Seminar" },
  { value: "exhibition", label: "Exhibition" },
];

export const timezones = [
  { value: "UTC", label: "UTC (Coordinated Universal Time)" },
  { value: "EST", label: "EST (Eastern Standard Time)" },
  { value: "PST", label: "PST (Pacific Standard Time)" },
  { value: "GMT", label: "GMT (Greenwich Mean Time)" },
  { value: "CET", label: "CET (Central European Time)" },
  { value: "JST", label: "JST (Japan Standard Time)" },
];

export const categoryOptions = [
  { value: "hotels", label: "Hotels & Resorts" },
  { value: "dmc", label: "Destination Management Companies" },
  { value: "airlines", label: "Airlines" },
  { value: "venues", label: "Event Venues" },
  { value: "tours", label: "Tour Operators" },
  { value: "transport", label: "Transportation" },
  { value: "technology", label: "Travel Technology" },
  { value: "services", label: "Travel Services" },
];

export const calendarOptions = [
  { value: 1, label: "1 Calendar" },
  { value: 2, label: "2 Calendars" },
  { value: 3, label: "3 Calendars" },
];

export const durationOptions = [
  { value: 15, label: "15 minutes" },
  { value: 30, label: "30 minutes" },
  { value: 45, label: "45 minutes" },
  { value: 60, label: "1 hour" },
  { value: 90, label: "1.5 hours" },
  { value: 120, label: "2 hours" },
];
// Mock event data
export const eventData = {
  id: "evt-001",
  title: "Global Travel Summit 2024",
  description: `The Global Travel Summit 2024 is the premier B2B networking event for travel industry professionals worldwide. 
    This three-day summit brings together travel buyers, suppliers, technology providers, and industry leaders to explore 
    emerging trends, forge new partnerships, and drive innovation in the travel sector.`,
  type: "Conference",
  status: "upcoming",
  startDate: "2024-07-15T09:00:00",
  endDate: "2024-07-17T18:00:00",
  bannerImage:
    "https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=800&h=400&fit=crop",
  location: {
    venue: "Marina Bay Convention Centre",
    address: "10 Marina Boulevard, Singapore 018983",
    city: "Singapore",
    country: "Singapore",
    phone: "+65 6688 8888",
    coordinates: {
      lat: 1.2834,
      lng: 103.8607,
    },
  },
  organizer: {
    name: "Global Travel Events Ltd.",
    type: "Event Management Company",
    description:
      "Leading organizer of B2B travel industry events across Asia-Pacific region.",
    logo: "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=100&h=100&fit=crop",
    contact: {
      email: "info@globaltravelevents.com",
      phone: "+65 6123 4567",
    },
  },
  stats: {
    totalAttendees: 1250,
    exhibitors: 180,
    Calendar: 45,
    meetings: 12,
    sessions: 30,
  },
  tags: [
    "B2B Travel",
    "Networking",
    "Technology",
    "Sustainability",
    "Innovation",
    "Asia-Pacific",
  ],
};

// Mock agenda data
export const agendaData = [
  {
    date: "July 15, 2024",
    sessions: [
      {
        id: "session-001",
        title: "Opening Keynote: The Future of Travel Technology",
        description:
          "Industry leaders discuss emerging technologies shaping the future of travel.",
        type: "keynote",
        startTime: "09:00",
        endTime: "10:00",
        duration: 60,
        location: "Main Auditorium",
        speakers: [
          {
            name: "Sarah Chen",
            title: "CEO",
            company: "TravelTech Innovations",
            avatar: "https://randomuser.me/api/portraits/women/1.jpg",
          },
          {
            name: "Michael Rodriguez",
            title: "CTO",
            company: "Global Booking Systems",
            avatar: "https://randomuser.me/api/portraits/men/1.jpg",
          },
        ],
        materials: [
          {
            title: "Keynote Presentation Slides",
            type: "PDF",
            url: "/materials/keynote-slides.pdf",
          },
        ],
      },
      {
        id: "session-002",
        title: "Panel: Sustainable Travel Practices",
        description:
          "Experts discuss sustainable tourism and eco-friendly travel solutions.",
        type: "panel",
        startTime: "10:30",
        endTime: "11:30",
        duration: 60,
        location: "Conference Room A",
        speakers: [
          {
            name: "Emma Thompson",
            title: "Sustainability Director",
            company: "EcoTravel Solutions",
            avatar: "https://randomuser.me/api/portraits/women/2.jpg",
          },
        ],
        materials: [],
      },
    ],
  },
  {
    date: "July 16, 2024",
    sessions: [
      {
        id: "session-003",
        title: "Workshop: AI in Travel Booking",
        description:
          "Hands-on workshop exploring AI applications in travel booking systems.",
        type: "workshop",
        startTime: "09:00",
        endTime: "12:00",
        duration: 180,
        location: "Workshop Room 1",
        speakers: [
          {
            name: "David Kim",
            title: "AI Research Lead",
            company: "Smart Travel AI",
            avatar: "https://randomuser.me/api/portraits/men/2.jpg",
          },
        ],
        materials: [
          {
            title: "Workshop Materials",
            type: "ZIP",
            url: "/materials/ai-workshop.zip",
          },
        ],
      },
    ],
  },
];

// Mock exhibitors data
export const exhibitorsData = [
  {
    id: "exhibitor-001",
    name: "Luxury Hotels International",
    category: "hotels",
    description:
      "Premium hotel chain offering luxury accommodations worldwide with exceptional service and amenities.",
    logo: "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=100&h=100&fit=crop",
    bannerImage:
      "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=400&h=200&fit=crop",
    boothNumber: "A-101",
    availability: "available",
    rating: 4.8,
    reviews: 156,
    members: [
      {
        firstName: "Liam",
        lastName: "Patel",
        designation: "Head of Guest Services",
        availableSlots: 25,
      },
      {
        firstName: "Olivia",
        lastName: "Chen",
        designation: "Senior Marketing Manager",
        availableSlots: 32,
      },
      {
        firstName: "Noah",
        lastName: "Garcia",
        designation: "Global Sales Director",
        availableSlots: 18,
      },
    ],
  },
  {
    id: "exhibitor-002",
    name: "TechTravel Solutions",
    category: "technology",
    description:
      "Innovative travel technology solutions for booking systems, mobile apps, and customer management.",
    logo: "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=100&h=100&fit=crop",
    bannerImage:
      "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=400&h=200&fit=crop",
    boothNumber: "B-205",
    availability: "busy",
    rating: 4.6,
    reviews: 89,
    members: [
      {
        firstName: "Emma",
        lastName: "Jones",
        designation: "Lead Software Engineer",
        availableSlots: 45,
      },
      {
        firstName: "William",
        lastName: "Lee",
        designation: "Product Manager",
        availableSlots: 21,
      },
      {
        firstName: "Ava",
        lastName: "Brown",
        designation: "UX/UI Designer",
        availableSlots: 38,
      },
    ],
  },
  {
    id: "exhibitor-003",
    name: "Asia DMC Network",
    category: "dmc",
    description:
      "Leading destination management company providing comprehensive travel services across Asia.",
    logo: "https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=100&h=100&fit=crop",
    bannerImage:
      "https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=400&h=200&fit=crop",
    boothNumber: "C-312",
    availability: "available",
    rating: 4.7,
    reviews: 203,
    members: [
      {
        firstName: "Oliver",
        lastName: "Kim",
        designation: "Operations Manager",
        availableSlots: 15,
      },
      {
        firstName: "Sophia",
        lastName: "Singh",
        designation: "Regional Sales Executive",
        availableSlots: 29,
      },
      {
        firstName: "Elijah",
        lastName: "Tan",
        designation: "Client Relations Specialist",
        availableSlots: 41,
      },
    ],
  },
];

// Mock attendees data
export const attendeesData = [
  {
    id: "company-001",
    name: "Corporate Travel Solutions",
    category: "travel_agency",
    description:
      "A leading corporate travel management company that provides solutions for businesses to streamline their travel programs, manage costs, and ensure traveler safety.",
    logo: "https://logoipsum.com/artwork/8.svg",
    bannerImage: "https://source.unsplash.com/featured/?corporate,travel",
    boothNumber: "",
    availability: "online",
    rating: 4.9,
    reviews: 45,
    members: [
      {
        firstName: "Jennifer",
        lastName: "Walsh",
        designation: "Travel Manager",
        availableSlots: 34,
      },
      {
        firstName: "Michael",
        lastName: "Stevens",
        designation: "Client Success Lead",
        availableSlots: 12,
      },
      {
        firstName: "Sophie",
        lastName: "Nguyen",
        designation: "Operations Coordinator",
        availableSlots: 20,
      },
    ],
  },
  {
    id: "company-002",
    name: "Boutique Hotels Group",
    category: "hotel",
    description:
      "A collection of luxury boutique hotels located in key destinations across Europe, known for their unique character, design, and personalized service.",
    logo: "https://logoipsum.com/artwork/5.svg",
    bannerImage: "https://source.unsplash.com/featured/?luxury,hotel",
    boothNumber: "",
    availability: "away",
    rating: 4.7,
    reviews: 67,
    members: [
      {
        firstName: "Carlos",
        lastName: "Martinez",
        designation: "Sales Director",
        availableSlots: 20,
      },
      {
        firstName: "Elena",
        lastName: "Rossi",
        designation: "Hospitality Consultant",
        availableSlots: 16,
      },
      {
        firstName: "George",
        lastName: "Lam",
        designation: "Revenue Manager",
        availableSlots: 28,
      },
    ],
  },
  {
    id: "company-003",
    name: "TravelTech Innovations",
    category: "technology",
    description:
      "A forward-thinking technology company that develops software and platforms to enhance the travel booking and management experience for businesses and consumers.",
    logo: "https://logoipsum.com/artwork/12.svg",
    bannerImage: "https://source.unsplash.com/featured/?technology,software",
    boothNumber: "",
    availability: "online",
    rating: 4.8,
    reviews: 32,
    members: [
      {
        firstName: "Priya",
        lastName: "Sharma",
        designation: "Product Manager",
        availableSlots: 1,
      },
      {
        firstName: "David",
        lastName: "Kim",
        designation: "Software Architect",
        availableSlots: 10,
      },
      {
        firstName: "Amelia",
        lastName: "Clark",
        designation: "UX Designer",
        availableSlots: 25,
      },
    ],
  },
];

// Mock meetings data
export const meetingsData = [
  {
    id: "meeting-001",
    title: "Partnership Discussion",
    description:
      "Explore potential partnership opportunities for corporate travel programs.",
    date: "2024-07-15",
    startTime: "10:00",
    duration: 30,
    status: "confirmed",
    type: "One-on-One",
    location: "Meeting Room 1A",
    attendee: {
      name: "Jennifer Walsh",
      title: "Travel Manager",
      company: "Corporate Travel Solutions",
      avatar: "https://randomuser.me/api/portraits/women/3.jpg",
    },
    agenda: [
      "Introduction and company overview",
      "Discussion of partnership opportunities",
      "Pricing and service level agreements",
      "Next steps and follow-up",
    ],
    meetingLink: null,
  },
  {
    id: "meeting-002",
    title: "Technology Integration Meeting",
    description:
      "Technical discussion about API integration and system compatibility.",
    date: "2024-07-16",
    startTime: "14:00",
    duration: 45,
    status: "pending",
    type: "Virtual",
    location: "Virtual Meeting",
    attendee: {
      name: "Priya Sharma",
      title: "Product Manager",
      company: "TravelTech Innovations",
      avatar: "https://randomuser.me/api/portraits/women/4.jpg",
    },
    agenda: [
      "API documentation review",
      "Integration requirements",
      "Testing and implementation timeline",
    ],
    meetingLink: "https://meet.example.com/tech-integration",
  },
];

// Mock related events
export const relatedEventsData = [
  {
    id: "related-001",
    title: "Asia Travel Expo 2024",
    date: "Aug 20-22, 2024",
    location: "Bangkok",
    attendees: 800,
    image:
      "https://images.unsplash.com/photo-1469474968028-56623f02e42e?w=100&h=100&fit=crop",
  },
  {
    id: "related-002",
    title: "Corporate Travel Summit",
    date: "Sep 15-16, 2024",
    location: "London",
    attendees: 650,
    image:
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=100&h=100&fit=crop",
  },
];

// Mock networking suggestions
export const networkingSuggestionsData = [
  {
    id: "suggestion-001",
    name: "Robert Chen",
    title: "VP Sales",
    company: "Premium Destinations",
    avatar: "https://randomuser.me/api/portraits/men/4.jpg",
    matchScore: 92,
    reason: "Similar interests in luxury travel and B2B partnerships",
  },
  {
    id: "suggestion-002",
    name: "Lisa Anderson",
    title: "Technology Director",
    company: "Smart Travel Systems",
    avatar: "https://randomuser.me/api/portraits/women/5.jpg",
    matchScore: 87,
    reason: "Complementary expertise in travel technology solutions",
  },
];

export const statistics = [
  {
    label: "Total Buyers",
    value: eventData.stats.totalAttendees,
    icon: "Users",
  },
  { label: "Exhibitors", value: eventData.stats.exhibitors, icon: "Building" },
  {
    label: "Total Calendars",
    value: eventData.stats.Calendar,
    icon: "Calendar",
  },
  {
    label: "Total meetings",
    value: eventData.stats.meetings,
    icon: "Clock",
  },
  {
    label: "Total Agenda Sessions",
    value: eventData.stats.sessions,
    icon: "MessagesSquare",
  },
];
export const keyFeatures = [
  "AI-Powered Matchmaking",
  "One-on-One Meeting Scheduler",
  "Digital Business Card Exchange",
  "Live Q&A Sessions",
  "Virtual Networking Lounges",
  "Resource Download Center",
];

export const roleOptions = [
  { value: "all", label: "All Roles" },
  { value: "buyer", label: "Buyers" },
  { value: "seller", label: "Sellers" },
  { value: "organizer", label: "Organizers" },
  { value: "speaker", label: "Speakers" },
];

export const dayOptions = [
  { value: "all", label: "All Days" },
  { value: "2024-07-15", label: "July 15, 2024" },
  { value: "2024-07-16", label: "July 16, 2024" },
  { value: "2024-07-17", label: "July 17, 2024" },
];

export const statusOptions = [
  { value: "all", label: "All Status" },
  { value: "confirmed", label: "Confirmed" },
  { value: "pending", label: "Pending" },
  { value: "cancelled", label: "Cancelled" },
];

export const getStatusColor = (status) => {
  switch (status) {
    case "completed":
      return "bg-success text-success-foreground";
    case "cancelled":
      return "bg-error text-error-foreground";
    case "in-progress":
      return "bg-warning text-warning-foreground";
    default:
      return "bg-secondary text-secondary-foreground";
  }
};

export const getVerificationColor = (status) => {
  switch (status) {
    case "verified":
      return "text-success";
    case "pending":
      return "text-warning";
    case "rejected":
      return "text-error";
    default:
      return "text-secondary";
  }
};

export const getTypeIcon = (type) => {
  return type === "buyer" ? "ShoppingCart" : "Store";
};

export const mockAnnouncements = [
  {
    id: 1,
    type: "message",
    audience: "all",
    content: "🎉 Welcome to EPEX 2025! We’re excited to have you onboard.",
    createdAt: "2025-07-15T10:30:00Z",
  },
  {
    id: 2,
    type: "image",
    audience: "buyers only",
    content: "announcement.jpg", //
    createdAt: "2025-07-14T08:00:00Z",
  },
  {
    id: 3,
    type: "message",
    audience: "sellers only",
    content: "🛍️ Sellers, please complete your profile before July 20!",
    createdAt: "2025-07-13T15:45:00Z",
  },
];

export const formatDate = (isoDate) => {
  const options = { year: "numeric", month: "short", day: "numeric" };
  return new Date(isoDate).toLocaleDateString(undefined, options);
};

export const meetingContacts = [
  {
    id: 1,
    name: "Michael Rodriguez",
    company: "Global Travel Solutions",
    role: "Senior Travel Manager",
    type: "buyer",
    status: "available",
    availableSlots: 12,
    avatar:
      "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
    location: "New York, NY",
    timezone: "EST",
    previousMeetings: 3,
    calendars: ["primary"],
  },
  {
    id: 2,
    name: "Sarah Chen",
    company: "Luxury Hotels International",
    role: "Business Development Director",
    type: "exhibitor",
    status: "busy",
    availableSlots: 8,
    avatar:
      "https://images.unsplash.com/photo-1494790108755-2616b9e0e4d4?w=150&h=150&fit=crop&crop=face",
    location: "London, UK",
    timezone: "GMT",
    previousMeetings: 1,
    calendars: ["primary", "events", "meetings"],
  },
  {
    id: 3,
    name: "David Thompson",
    company: "Adventure Tours Ltd",
    role: "Operations Manager",
    type: "exhibitor",
    status: "available",
    availableSlots: 15,
    avatar:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
    location: "Sydney, AU",
    timezone: "AEST",
    previousMeetings: 0,
    calendars: ["primary", "operations"],
  },
  {
    id: 4,
    name: "Emma Wilson",
    company: "Corporate Events Pro",
    role: "Event Coordinator",
    type: "buyer",
    status: "available",
    availableSlots: 10,
    avatar:
      "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
    location: "Toronto, CA",
    timezone: "EST",
    previousMeetings: 2,
    calendars: ["primary"],
  },
  {
    id: 5,
    name: "James Park",
    company: "Tech Travel Innovations",
    role: "Product Manager",
    type: "speaker",
    status: "unavailable",
    availableSlots: 5,
    avatar:
      "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop&crop=face",
    location: "San Francisco, CA",
    timezone: "PST",
    previousMeetings: 4,
    calendars: ["primary"],
  },
  {
    id: 6,
    name: "Lisa Martinez",
    company: "Destination Marketing Board",
    role: "Marketing Director",
    type: "sponsor",
    status: "available",
    availableSlots: 18,
    avatar:
      "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face",
    location: "Miami, FL",
    timezone: "EST",
    previousMeetings: 1,
    calendars: ["primary", "marketing"],
  },
];

// Mock scheduled meetings
export const mockScheduledMeetings = [
  {
    id: 1,
    title: "Partnership Discussion",
    date: new Date(2024, 6, 15),
    displayTime: "2:00 PM",
    duration: "30",
    purpose: "partnership",
    location: "virtual",
    status: "upcoming",
    participants: [contacts[0], contacts[1]],
    agenda:
      "Discuss potential partnership opportunities for luxury travel packages",
    allowRescheduling: true,
    sendReminders: true,
    includeCalendarInvite: true,
    createdAt: new Date().toISOString(),
  },
  {
    id: 2,
    title: "Product Demo Session",
    date: new Date(2024, 6, 16),
    displayTime: "10:30 AM",
    duration: "45",
    purpose: "product_demo",
    location: "conference_room",
    status: "upcoming",
    participants: [contacts[2], contacts[3]],
    agenda: "Demonstration of new adventure booking platform features",
    allowRescheduling: true,
    sendReminders: true,
    includeCalendarInvite: true,
    createdAt: new Date().toISOString(),
  },
  {
    id: 3,
    title: "Marketing Strategy Meeting",
    date: new Date(2024, 6, 12),
    displayTime: "3:00 PM",
    duration: "60",
    purpose: "business_discussion",
    location: "virtual",
    status: "completed",
    participants: [contacts[4], contacts[5]],
    agenda: "Review Q3 marketing strategies and campaign performance",
    allowRescheduling: false,
    sendReminders: true,
    includeCalendarInvite: true,
    createdAt: new Date().toISOString(),
  },
];

export const mockRecentActivityContact = [
  {
    id: 1,
    user: {
      id: 1,
      name: "Sarah Johnson",
      avatar:
        "https://images.unsplash.com/photo-1494790108755-2616b9c7e6e5?w=150&h=150&fit=crop&crop=face",
    },
    type: "connection",
    description: "connected with Michael Chen",
    timestamp: new Date(Date.now() - 300000),
    relatedEvent: "Travel Tech Summit 2024",
  },
  {
    id: 2,
    user: {
      id: 3,
      name: "Emma Rodriguez",
      avatar:
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
    },
    type: "event_join",
    description: "joined Destination Marketing Forum",
    timestamp: new Date(Date.now() - 3600000),
    relatedEvent: "Destination Marketing Forum",
  },
  {
    id: 3,
    user: {
      id: 4,
      name: "David Kim",
      avatar:
        "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
    },
    type: "meeting_scheduled",
    description: "scheduled a meeting with Lisa Thompson",
    timestamp: new Date(Date.now() - 7200000),
    details: "Meeting scheduled for July 16, 2024 at 2:00 PM",
  },
];

export const mockNetworkingSuggestions = [
  {
    id: 101,
    name: "Jennifer Walsh",
    title: "Travel Technology Specialist",
    company: "TravelTech Solutions",
    avatar:
      "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=150&h=150&fit=crop&crop=face",
    reason: "ai_match",
    matchScore: 92,
    mutualConnections: 4,
    isOnline: true,
  },
  {
    id: 102,
    name: "Robert Anderson",
    title: "Hotel Revenue Manager",
    company: "Boutique Hotels Group",
    avatar:
      "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=150&h=150&fit=crop&crop=face",
    reason: "mutual_connections",
    matchScore: 85,
    mutualConnections: 8,
    isOnline: false,
  },
  {
    id: 103,
    name: "Maria Santos",
    title: "Event Coordinator",
    company: "Global Events Network",
    avatar:
      "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=150&h=150&fit=crop&crop=face",
    reason: "same_event",
    matchScore: 78,
    mutualConnections: 2,
    isOnline: true,
  },
];

export const mockContacts = [
  {
    id: 1,
    name: "Sarah Johnson",
    title: "Senior Travel Manager",
    company: "Global Travel Solutions",
    role: "buyer",
    industry: "Corporate Travel",
    location: "New York, USA",
    avatar:
      "https://images.unsplash.com/photo-1494790108755-2616b9c7e6e5?w=150&h=150&fit=crop&crop=face",
    connectionStatus: "connected",
    isOnline: true,
    isFollowing: false,
    mutualConnections: 12,
    recentActivity: "Attended Travel Tech Summit 2024",
    activityTime: "2 days ago",
    commonEvents: ["Travel Tech Summit 2024", "Global Tourism Expo"],
    isVerified: true,
  },
  {
    id: 2,
    name: "Michael Chen",
    title: "Hotel Operations Director",
    company: "Luxury Hotels International",
    role: "seller",
    industry: "Hospitality",
    location: "Singapore",
    avatar:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
    connectionStatus: "pending",
    isOnline: false,
    isFollowing: true,
    mutualConnections: 8,
    recentActivity: "Updated company profile",
    activityTime: "1 hour ago",
    commonEvents: ["Hospitality Connect", "Travel Tech Summit 2024"],
    isVerified: true,
  },
  {
    id: 3,
    name: "Emma Rodriguez",
    title: "DMC Operations Manager",
    company: "Mediterranean Destinations",
    role: "seller",
    industry: "Destination Management",
    location: "Barcelona, Spain",
    avatar:
      "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
    connectionStatus: "none",
    isOnline: true,
    isFollowing: false,
    mutualConnections: 5,
    recentActivity: "Created new event",
    activityTime: "3 hours ago",
    commonEvents: ["Destination Marketing Forum"],
    isVerified: false,
  },
  {
    id: 4,
    name: "David Kim",
    title: "Corporate Travel Coordinator",
    company: "Tech Innovations Inc",
    role: "buyer",
    industry: "Technology",
    location: "Seoul, South Korea",
    avatar:
      "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
    connectionStatus: "following",
    isOnline: true,
    isFollowing: true,
    mutualConnections: 15,
    recentActivity: "Joined new event",
    activityTime: "5 hours ago",
    commonEvents: ["Travel Tech Summit 2024", "Global Tourism Expo"],
    isVerified: true,
  },
  {
    id: 5,
    name: "Lisa Thompson",
    title: "Event Venue Manager",
    company: "Premier Event Spaces",
    role: "seller",
    industry: "Event Management",
    location: "London, UK",
    avatar:
      "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face",
    connectionStatus: "connected",
    isOnline: false,
    isFollowing: false,
    mutualConnections: 7,
    recentActivity: "Scheduled meeting",
    activityTime: "1 day ago",
    commonEvents: ["Hospitality Connect"],
    isVerified: true,
  },
  {
    id: 6,
    name: "Carlos Martinez",
    title: "Tour Operations Director",
    company: "Adventure Travel Co",
    role: "seller",
    industry: "Adventure Tourism",
    location: "Mexico City, Mexico",
    avatar:
      "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop&crop=face",
    connectionStatus: "none",
    isOnline: true,
    isFollowing: false,
    mutualConnections: 3,
    recentActivity: "Posted business update",
    activityTime: "6 hours ago",
    commonEvents: ["Global Tourism Expo"],
    isVerified: false,
  },
];

export const mockSavedSearches = [
  {
    id: 1,
    name: "Hotel Partners",
    filters: { companyType: "hotel", role: "seller" },
    createdAt: "2024-07-10",
  },
  {
    id: 2,
    name: "Tech Summit Attendees",
    filters: { event: "travel-tech-summit-2024" },
    createdAt: "2024-07-08",
  },
];

export const whoMetOptions = [
  { value: "all", label: "All Who Met" },
  { value: "met-by-you", label: "Met by You" },
  { value: "met-by-collegue", label: "Met by Colleague" },
];

export const eventOptions = [
  { value: "all", label: "All Events" },
  { value: "travel-tech-summit-2024", label: "Travel Tech Summit 2024" },
  { value: "global-tourism-expo", label: "Global Tourism Expo" },
  { value: "hospitality-connect", label: "Hospitality Connect" },
  {
    value: "destination-marketing-forum",
    label: "Destination Marketing Forum",
  },
];

export const companyTypeOptions = [
  { value: "all", label: "All Company Types" },
  { value: "travel-agency", label: "Travel Agency" },
  { value: "hotel", label: "Hotel" },
  { value: "dmc", label: "DMC (Destination Management)" },
  { value: "tour-operator", label: "Tour Operator" },
  { value: "venue", label: "Venue" },
  { value: "technology", label: "Technology Provider" },
  { value: "airline", label: "Airline" },
  { value: "cruise", label: "Cruise Line" },
];

export const roleOptionsContacts = [
  { value: "all", label: "All Roles" },
  { value: "buyer", label: "Buyer" },
  { value: "seller", label: "Seller" },
  { value: "admin", label: "Admin" },
];

export const locationOptions = [
  { value: "all", label: "All Locations" },
  { value: "north-america", label: "North America" },
  { value: "europe", label: "Europe" },
  { value: "asia-pacific", label: "Asia Pacific" },
  { value: "middle-east", label: "Middle East" },
  { value: "africa", label: "Africa" },
  { value: "south-america", label: "South America" },
];

export const connectionStatusOptions = [
  { value: "all", label: "All Connections" },
  { value: "connected", label: "Connected" },
  { value: "pending", label: "Pending" },
  { value: "following", label: "Following" },
  { value: "none", label: "Not Connected" },
];

export const statusOptionsCalendar = [
  { value: "all", label: "All Meetings" },
  { value: "upcoming", label: "Upcoming" },
  { value: "completed", label: "Completed" },
  { value: "cancelled", label: "Cancelled" },
];

export const sortOptionsCalendar = [
  { value: "date", label: "Date" },
  { value: "title", label: "Title" },
  { value: "participants", label: "Participants" },
];

export const exportFormatOptions = [
  { value: "csv", label: "CSV File" },
  { value: "excel", label: "Excel File" },
  { value: "pdf", label: "PDF Report" },
  { value: "vcard", label: "vCard Format" },
];

export const messageTemplates = [
  {
    value: "custom",
    label: "Custom Message",
  },
  {
    value: "professional",
    label: "Professional Introduction",
    content: `Hi \${name},\n\nI'd like to connect with you on TravelConnect Pro. I believe we could benefit from sharing insights and exploring potential collaboration opportunities in the travel industry.\n\nLooking forward to connecting!\n\nBest regards`,
  },
  {
    value: "event_based",
    label: "Event-Based Connection",
    content: `Hi \${name},\n\nI noticed we're both attending/have attended similar travel industry events. I'd love to connect and continue our networking beyond the events.\n\nLooking forward to connecting!\n\nBest regards`,
  },
  {
    value: "mutual_connection",
    label: "Mutual Connection",
    content: `Hi \${name},\n\nI see we have mutual connections in the travel industry. I'd like to expand my professional network and connect with fellow industry professionals.\n\nLooking forward to connecting!\n\nBest regards`,
  },
  {
    value: "business_opportunity",
    label: "Business Opportunity",
    content: `Hi \${name},\n\nI'm interested in exploring potential business opportunities and partnerships in the travel industry. I believe our companies could benefit from connecting.\n\nLooking forward to discussing further!\n\nBest regards`,
  },
];

export const purposeOptions = [
  { value: "business_discussion", label: "Business Discussion" },
  { value: "product_demo", label: "Product Demo" },
  { value: "partnership", label: "Partnership Opportunity" },
  { value: "networking", label: "Networking" },
  { value: "consultation", label: "Consultation" },
  { value: "follow_up", label: "Follow-up Meeting" },
  { value: "other", label: "Other" },
];

export const locationOptionsCalendar = [
  { value: "virtual", label: "Virtual Meeting (Zoom/Teams)" },
  { value: "office", label: "Office Meeting" },
  { value: "hotel_lobby", label: "Hotel Lobby" },
  { value: "conference_room", label: "Conference Room" },
  { value: "restaurant", label: "Restaurant/Café" },
  { value: "custom", label: "Custom Location" },
];

export const filterOptionsCalendar = [
  { value: "all", label: "All Contacts" },
  { value: "exhibitors", label: "Exhibitors" },
  { value: "buyers", label: "Buyers" },
  { value: "speakers", label: "Speakers" },
  { value: "sponsors", label: "Sponsors" },
];

export const sortOptionsContactPanel = [
  { value: "name", label: "Name" },
  { value: "company", label: "Company" },
  { value: "role", label: "Role" },
  { value: "availability", label: "Availability" },
];

export const spacingOptions = [
  { value: "0", label: "No spacing" },
  { value: "15", label: "15 minutes" },
  { value: "30", label: "30 minutes" },
  { value: "60", label: "1 hour" },
];

export const modeOptions = [
  { value: "sequential", label: "Sequential (one after another)" },
  { value: "parallel", label: "Parallel (same time slots)" },
];

export const pastBusinessActivities = [
  {
    id: 1,
    // basic info
    eventName: "Hotel Booking for Corporate Retreat",
    activityType: "Corporate Incentive", // should match your activityTypeOptions value
    otherActivity:
      "Corporate retreat for senior leadership. Needed hotel block, transfers, and meeting rooms.",
    // metrics
    totalParticipants: 52,
    totalNights: 3,
    eventMonthYear: "2025-02", // <-- this is how your <input type="month" /> saves it
    dollarValue: "85000 USD",
    // file
    supportingDocumentUrl:
      "https://example.com/uploads/corporate-retreat-brief.pdf",
    // destinations
    destinationsCount: 2,
    destinations: [
      {
        country: "UAE",
        city: "Dubai",
        hotel: "Grand Palm Resort",
        nights: 2,
        contact: "Ayesha Khan",
        email: "ayesha.khan@grandpalm.com",
      },
      {
        country: "UAE",
        city: "Abu Dhabi",
        hotel: "Emirates Business Hotel",
        nights: 1,
        contact: "Mohammed Al Rashid",
        email: "m.rashid@emiratesbusiness.ae",
      },
    ],
    // tourism board
    tourismBoardSupport: true,
    tourismBoard: {
      name: "Dubai Tourism & Commerce Marketing",
      contact: "Mr. Faisal",
      email: "faisal@visitdubai.ae",
      description: "Provided venue suggestions and local experiences.",
    },
    // dmc
    usedDMC: true,
    dmc: {
      name: "Desert Dunes DMC",
      contact: "Sarah Lee",
      email: "sarah@desertdunesdmc.com",
    },
    // upcoming event
    upcomingEventName: "Leadership Offsite 2025",
    upcomingEventDate: "2025-05-12",
    upcomingEventCity: "Muscat",
    upcomingEventCountry: "Oman",
    upcomingEventParticipants: "35",
    upcomingEventRequirements: "Need 2 breakout rooms + airport transfers",
    status: "completed",
    verifiedNumber: "4",
    requestedNumber: "6",
  },
  {
    id: 2,
    eventName: "Incentive Group – APAC Distributors",
    activityType: "International Exhibition",
    otherActivity:
      "Reward trip for top-performing distributors. Included sightseeing, gala dinner, and hotel stay.",
    totalParticipants: 30,
    totalNights: 4,
    eventMonthYear: "2025-03",
    dollarValue: "42000 USD",
    supportingDocumentUrl: "",
    destinationsCount: 1,
    destinations: [
      {
        country: "Thailand",
        city: "Bangkok",
        hotel: "Riverside Crown Hotel",
        nights: 4,
        contact: "Pimchanok",
        email: "sales@riversidecrown.th",
      },
    ],
    tourismBoardSupport: false,
    tourismBoard: {
      name: "",
      contact: "",
      email: "",
      description: "",
    },
    usedDMC: true,
    dmc: {
      name: "Bangkok Smiles DMC",
      contact: "Krit",
      email: "krit@bkk-smiles.com",
    },
    upcomingEventName: "",
    upcomingEventDate: "",
    upcomingEventCity: "",
    upcomingEventCountry: "",
    upcomingEventParticipants: "",
    upcomingEventRequirements: "",
    status: "completed",
    verifiedNumber: "6",
    requestedNumber: "6",
  },
];

// mockBusinessActivities.js

export const mockBusinessActivitiesSeller = [
  // 1) Hotels & Hospitality submitted
  {
    id: 1,
    organizationType: "hotel", // DetailPage3A
    eventName: "Luxury MICE Stay",
    eventType: "Conference",
    customEventType: "2-day conference + 1 gala dinner at the hotel ballroom.",
    totalPax: 120,
    nights: 2,
    eventMonthYear: "2025-02",
    dollarValue: "25,000",
    documentFile: null, // you can map to documentUrl if needed
    documentUrl: "https://example.com/hotel-mice-program.pdf",

    // agency section
    agencyName: "ABC Experiential Pvt Ltd",
    showAgencyContact: true,
    agencyContactName: "Riya Shah",
    agencyCompanyName: "ABC Experiential Pvt Ltd",
    agencyContactEmail: "riya.shah@abcexperiential.com",

    // DMC section
    usedDmc: true,
    dmcName: "Desert Trails DMC",
    dmcPocName: "Ahmed Khan",
    dmcPocEmail: "ahmed@deserttrails.ae",
    dmcPocPhone: "+971-50-444444",

    // Tourism section
    usedTourism: true,
    tourismName: "Dubai Department of Economy & Tourism",
    tourismPocName: "Hiba Saleh",
    tourismPocEmail: "hiba@det.gov.ae",
    tourismPocPhone: "+971-4-1234567",
    status: "completed",
    verifiedNumber: "1",
    requestedNumber: "6",
  },

  // 2) Tourism Board / Convention Bureau submitted
  {
    id: 2,
    organizationType: "tourism_board", // bucket: DetailsPage3B
    eventName: "Abu Dhabi Roadshow",
    eventType: "Destination Promotion",
    totalPax: 80,
    nights: 2,
    eventMonthYear: "2025-01",
    dollarValue: "8,000",
    customEventType: "Showcased hotels, venues and new attractions.",
    supportingDocumentUrl: "https://example.com/sample.pdf",

    // hotel details (because your tourism form had it)
    hotelName: "Grand Marina Hotel",
    hotelCity: "Abu Dhabi",
    hotelCountry: "UAE",
    hotelPocName: "Sarah Al Nahyan",
    hotelPocEmail: "sarah@grandmarina.ae",
    hotelPocPhone: "+971-55-999999",
    hotelNeedsApproval: true,

    // DMC details (section 3 in tourism form)
    usedDmc: true,
    dmcName: "Desert Trails DMC",
    dmcPocName: "Ahmed Khan",
    dmcPocEmail: "ahmed@deserttrails.ae",
    dmcPocPhone: "+971-55-444444",

    tourismBoardSupport: true,
    tourismBoard: {
      name: "Abu Dhabi Convention Bureau",
      contact: "Sarah",
      email: "support@adcb.ae",
      description: "Marketing support and venue recommendation",
    },

    // optional destinations (your earlier display can show these)
    destinations: [
      {
        country: "UAE",
        city: "Abu Dhabi",
        hotel: "Grand Marina Hotel",
        nights: 2,
        contact: "Sarah",
        email: "sarah@grandmarina.ae",
      },
      {
        country: "UAE",
        city: "Dubai",
        hotel: "Grand Hyatt Hotel",
        nights: 2,
        contact: "Salim",
        email: "salim@hyatt.ae",
      },
    ],
    status: "completed",
    verifiedNumber: "1",
    requestedNumber: "6",
  },

  // 3) DMC submitted
  {
    id: 4,
    organizationType: "venue", // DetailPage3A
    eventName: "Product Launch for Automotive Client",
    eventType: "Product Launch",
    customEventType: "Half-day launch + media showcase in the main hall.",
    totalPax: 80,
    nights: 0,
    eventMonthYear: "2025-03",
    dollarValue: "11,500",
    documentFile: null,
    documentUrl: "",

    // agency section
    agencyName: "LaunchLab Events",
    showAgencyContact: false, // so your UI can hide that grid
    agencyContactName: "",
    agencyCompanyName: "",
    agencyContactEmail: "",

    // DMC section
    usedDmc: false,
    dmcName: "",
    dmcPocName: "",
    dmcPocEmail: "",
    dmcPocPhone: "",

    // Tourism section
    usedTourism: false,
    tourismName: "",
    tourismPocName: "",
    tourismPocEmail: "",
    tourismPocPhone: "",
    status: "completed",
    verifiedNumber: "1",
    requestedNumber: "6",
  },
  {
    id: 3,
    organizationType: "dmc", // bucket: DetailsPage3C
    eventName: "Safari & City Program",
    eventType: "DMC Activity",
    totalPax: 45,
    nights: 1,
    eventMonthYear: "2025-02",
    dollarValue: "5,500",
    customEventType: "Full-day city tour + desert safari for 45 pax.",
    supportingDocumentUrl: "",

    // DMC form says hotel must approve
    hotelName: "Desert Pearl Hotel",
    hotelCity: "Dubai",
    hotelCountry: "UAE",
    hotelPocName: "Mohammed Ali",
    hotelPocEmail: "mohammed@desertpearl.com",
    hotelPocPhone: "+971-50-222222",
    hotelNeedsApproval: true,

    tourismBoardSupport: false,
    usedDmc: false,
    destinations: [],
    status: "completed",
    verifiedNumber: "1",
    requestedNumber: "6",
  },
  {
    id: 5,
    organizationType: "attraction", // DetailPage3A
    eventName: "VIP Cruise Dinner Group",
    eventType: "Incentive",
    customEventType:
      "1-evening cruise for 35 pax, arranged via hotel concierge.",
    totalPax: 35,
    nights: 0,
    eventMonthYear: "2025-01",
    dollarValue: "4,200",
    documentFile: null,
    documentUrl: "https://example.com/cruise-details.pdf",

    // agency section
    agencyName: "Global Travel DWC",
    showAgencyContact: true,
    agencyContactName: "Sameer Shaikh",
    agencyCompanyName: "Global Travel DWC",
    agencyContactEmail: "sameer@globaltravel.ae",

    // DMC section
    usedDmc: true,
    dmcName: "Blue Waters DMC",
    dmcPocName: "Lina Faraz",
    dmcPocEmail: "lina@bluewatersdmc.com",
    dmcPocPhone: "+971-52-2222333",

    // Tourism section
    usedTourism: true,
    tourismName: "Abu Dhabi Convention & Exhibition Bureau",
    tourismPocName: "Sarah Al Nahyan",
    tourismPocEmail: "sarah@adceb.ae",
    tourismPocPhone: "+971-2-9876543",
    status: "completed",
    verifiedNumber: "1",
    requestedNumber: "6",
  },
  {
    id: 6,
    organizationType: "dmc",
    eventName: "Safari & City Program",
    eventType: "DMC Activity",
    totalPax: 45,
    nights: 1,
    eventMonthYear: "2025-02",
    dollarValue: "5,500",
    customEventType: "Full-day city tour + desert safari for 45 pax.",
    supportingDocumentUrl: "",
    hotelName: "Desert Pearl Hotel",
    hotelCity: "Dubai",
    hotelCountry: "UAE",
    hotelPocName: "Mohammed Ali",
    hotelPocEmail: "mohammed@desertpearl.com",
    hotelPocPhone: "+971-50-222222",
    hotelNeedsApproval: true,
    tourismBoardSupport: false,
    usedDmc: false,
    destinations: [],
    status: "completed",
    verifiedNumber: "1",
    requestedNumber: "6",
  },
];

export const filterActivitiesOptions = [
  { value: "all", label: "All Activities" },
  { value: "buyer", label: "Buyer Activities" },
  { value: "seller", label: "Seller Activities" },
];

export const sortActivitiesOptions = [
  { value: "date", label: "Date" },
  { value: "title", label: "Title" },
  { value: "rating", label: "Rating" },
  { value: "event", label: "Event" },
];

export const dateRangeOptions = [
  { value: "all", label: "All Time" },
  { value: "week", label: "Last Week" },
  { value: "month", label: "Last Month" },
  { value: "quarter", label: "Last Quarter" },
];

export const activityTypeOptions = [
  { value: "Corporate Incentive", label: "Corporate Incentive" },
  { value: "Corporate Meeting", label: "Corporate Meeting" },
  { value: "Corporate Conference", label: "Corporate Conference" },
  {
    value: "Sporting Event",
    label:
      "Corporate Group to Sporting/Entertainment Event (Example: Formula 1, World Cup)",
  },
  {
    value: "Special Interest Group (YPO, EO)",
    label: "Special Interest Group (YPO, EO)",
  },
  { value: "Association Congress", label: "Association Congress" },
  { value: "International Exhibitions", label: "International Exhibitions" },
  { value: "Destination Weddings", label: "Destination Weddings" },
  {
    value: "Destination Milestone Social Event",
    label: "Destination Milestone Social Event",
  },
  { value: "Other", label: "Other" },
];

export const eventTypesActivityForm = [
  { value: "Corporate Incentive", label: "Corporate Incentive" },
  { value: "Corporate Meeting", label: "Corporate Meeting" },
  { value: "Corporate Conference", label: "Corporate Conference" },
  {
    value: "Sporting Event",
    label:
      "Corporate Group to a Sporting or Entertainment Event (Example: Formula 1, World Cup)",
  },
  {
    value: "Special Interest Group (YPO, EO)",
    label: "Special Interest Group (YPO, EO)",
  },
  { value: "International Exhibitions", label: "International Exhibitions" },
  { value: "Destination Wedding", label: "Destination Wedding" },
  {
    value:
      "Destination Milestone Social Event (Birthdays, Anniversaries, etc.)",
    label:
      "Destination Milestone Social Event (Birthdays, Anniversaries, etc.)",
  },
  { value: "Other", label: "Other" },
];

export const countryOptionsActivityForm = [
  { value: "United States", label: "United States" },
  { value: "United Kingdom", label: "United Kingdom" },
  { value: "France", label: "France" },
  { value: "Japan", label: "Japan" },
  { value: "India", label: "India" },
  { value: "Australia", label: "Australia" },
  { value: "Canada", label: "Canada" },
  { value: "United Arab Emirates", label: "United Arab Emirates" },
];

export const newEventData = {
  title: "Luxury Travel Mart",
  days: [
    {
      date: "2025-09-10",
      slots: [
        { time: "10:00 AM", type: "available" },
        { time: "10:30 AM", type: "booked", meetingWith: "Taj Hotels" },
        { time: "12:30 PM", type: "blocked", meetingWith: "Lunch" },
        {
          time: "2:00 PM",
          type: "agenda",
          meetingWith: "Panel: Motivational Talk",
        },
      ],
    },
    {
      date: "2025-09-11",
      slots: [
        { time: "10:00 AM", type: "available" },
        { time: "10:30 AM", type: "booked", meetingWith: "Oberoi Group" },
        { time: "1:00 PM", type: "blocked", meetingWith: "Lunch Break" },
        { time: "3:00 PM", type: "agenda", meetingWith: "Closing Remarks" },
      ],
    },
  ],
};

export const receivedMeetingRequests = [
  {
    id: "req-1",
    fromName: "Alice Johnson",
    organizationName: "Digital Salt",
    date: "2025-01-25", // matches eventConfig
    time: "10:00 AM",
  },
  {
    id: "req-2",
    fromName: "Charlie Smith",
    organizationName: "PDS",
    date: "2025-01-26", // matches eventConfig
    time: "3:30 PM",
  },
];

export const sentMeetingRequests = [
  {
    id: "sent-1",
    toName: "David Williams",
    organizationName: "Hilton",
    date: "2025-01-25", // matches eventConfig
    time: "09:00 AM",
    status: "Accepted",
    rejectionReason: "",
  },
  {
    id: "sent-2",
    toName: "Emily Clark",
    organizationName: "Marriott",
    date: "2025-01-26", // matches eventConfig
    time: "01:00 PM",
    status: "Rejected",
    rejectionReason: "I am not looking to meet at this time",
  },
  {
    id: "sent-3",
    toName: "Zara Lee",
    organizationName: "TravelTech Innovations",
    date: "2025-01-27", // matches eventConfig
    time: "02:00 PM",
    status: "Pending",
    rejectionReason: "",
  },
];

export const mockEventUserList = [
  {
    userId: "user-1",
    fullName: "Razeen Pistawala",
    role: "Event Planner",
    adminMeetings: 12,
    sellerMeetings: 9,
    availableSlots: 24,
    hasCalendar: true,
  },
  {
    userId: "user-2",
    fullName: "Adnan Alvi",
    role: "Hotel & Hospitality",
    adminMeetings: 8,
    sellerMeetings: 7,
    availableSlots: 30,
    hasCalendar: true,
  },
  {
    userId: "user-3",
    fullName: "Priya Patel",
    role: "Logistics",
    adminMeetings: 5,
    sellerMeetings: 3,
    availableSlots: 15,
    hasCalendar: false,
  },
  {
    userId: "user-4",
    fullName: "Miguel Santos",
    role: "AV Services",
    adminMeetings: 10,
    sellerMeetings: 10,
    availableSlots: 20,
    hasCalendar: true,
  },
];

export const allUsers = [
  {
    id: 1,
    name: "Ayaan Farooqui",
    country: "India",
    orgType: "Buyer",
    event: "EPEX 2025",
    email: "ayaan@example.com",
  },
  {
    id: 2,
    name: "Hussain Charolia",
    country: "UAE",
    orgType: "Exhibitor",
    event: "EPEX 2025",
    email: "gulf@example.com",
  },
  {
    id: 3,
    name: "Atif Aslam",
    country: "Saudi Arabia",
    orgType: "Buyer",
    event: "Pre Event Mixer",
    email: "marhaba@example.com",
  },
];

export const orgTypeOptions = [
  // Hotels & Hospitality
  { label: "Hotel", value: "hotel" },
  { label: "Venue", value: "venue" },
  { label: "Convention centre", value: "convention centre" },
  { label: "Attraction", value: "attraction" },

  // Tourism Board
  { label: "National tourism org", value: "national tourism org" },
  { label: "Regional tourism org", value: "regional tourism org" },
  {
    label: "National convention bureau",
    value: "national convention bureau",
  },
  {
    label: "Regional convention bureau",
    value: "regional convention bureau",
  },

  // DMC / Representation
  { label: "DMC", value: "dmc" },
  { label: "Representation companies", value: "representation companies" },
];
